function PlanE({ ...props }) {
	return (
		<g {...props} id="unit-e">
			<g id="furniture">
				<polyline
					points="383.75 873.23 213.13 873.23 213.13 814.98 383.75 814.98 383.75 873.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="389.17 805.92 386.46 805.92 386.46 800.56 389.17 800.56 389.17 805.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="633.06"
					y1="540.56"
					x2="633.06"
					y2="504.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="540.56"
					x2="633.06"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.06"
					y1="504.16"
					x2="627.82"
					y2="504.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.32"
					y1="504.16"
					x2="618.5"
					y2="504.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="522.9"
					x2="516.56"
					y2="528.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="532.22"
					x2="516.56"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="538.14"
					x2="521.81"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.3"
					y1="538.14"
					x2="531.13"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.62"
					y1="538.14"
					x2="540.44"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.94"
					y1="538.14"
					x2="549.76"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.26"
					y1="538.14"
					x2="559.08"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.58"
					y1="538.14"
					x2="568.41"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.9"
					y1="538.14"
					x2="577.73"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.22"
					y1="538.14"
					x2="587.04"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.54"
					y1="538.14"
					x2="596.36"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.86"
					y1="538.14"
					x2="605.68"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.18"
					y1="538.14"
					x2="615"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.5"
					y1="538.14"
					x2="624.32"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.82"
					y1="538.14"
					x2="633.06"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.06"
					y1="538.14"
					x2="633.06"
					y2="532.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.06"
					y1="528.72"
					x2="633.06"
					y2="522.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.06"
					y1="519.4"
					x2="633.06"
					y2="513.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.06"
					y1="510.08"
					x2="633.06"
					y2="504.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.47"
					y1="532.33"
					x2="645.21"
					y2="532.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.47"
					y1="422.88"
					x2="750.47"
					y2="532.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.82"
					y1="422.88"
					x2="752.9"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="422.88"
					x2="752.9"
					y2="425.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="429.31"
					x2="752.9"
					y2="435.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="438.63"
					x2="752.9"
					y2="444.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="447.95"
					x2="752.9"
					y2="453.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="457.27"
					x2="752.9"
					y2="463.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="466.59"
					x2="752.9"
					y2="472.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="475.91"
					x2="752.9"
					y2="481.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="485.23"
					x2="752.9"
					y2="491.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="494.55"
					x2="752.9"
					y2="500.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="503.87"
					x2="752.9"
					y2="509.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="513.18"
					x2="752.9"
					y2="519.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="522.51"
					x2="752.9"
					y2="528.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="531.83"
					x2="752.9"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.9"
					y1="534.75"
					x2="747.4"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.9"
					y1="534.75"
					x2="738.08"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.58"
					y1="534.75"
					x2="728.76"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.26"
					y1="534.75"
					x2="719.44"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.94"
					y1="534.75"
					x2="710.12"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.62"
					y1="534.75"
					x2="700.8"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.3"
					y1="534.75"
					x2="691.48"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.98"
					y1="534.75"
					x2="682.16"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.67"
					y1="534.75"
					x2="672.84"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.35"
					y1="534.75"
					x2="663.52"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.03"
					y1="534.75"
					x2="654.2"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.71"
					y1="534.75"
					x2="645.21"
					y2="534.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.21"
					y1="534.75"
					x2="645.21"
					y2="540.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.21"
					y1="544.17"
					x2="645.21"
					y2="550"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="623.74 596.27 683.7 596.27 683.7 656.24 623.74 656.24 623.74 596.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="223.79 713.44 223.79 626.64 449.75 626.64 449.75 713.44 223.79 713.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="223.79"
					y1="713.44"
					x2="449.75"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.75"
					y1="713.44"
					x2="449.75"
					y2="626.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.75"
					y1="626.64"
					x2="223.79"
					y2="626.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.79"
					y1="626.64"
					x2="223.79"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="399.18 65.22 399.06 67.64 271.11 61.19 271.24 58.77 399.18 65.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="399.18"
					y1="65.22"
					x2="399.06"
					y2="67.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.06"
					y1="67.64"
					x2="271.11"
					y2="61.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.11"
					y1="61.19"
					x2="271.24"
					y2="58.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.24"
					y1="58.77"
					x2="399.18"
					y2="65.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="447.6 66.71 407.85 64.7 407.59 69.95 447.34 71.95 447.6 66.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="405.97 64.13 449.53 66.32 449.51 66.8 405.95 64.61 405.97 64.13"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="405.97"
					y1="64.13"
					x2="449.53"
					y2="66.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.53"
					y1="66.32"
					x2="449.51"
					y2="66.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.51"
					y1="66.8"
					x2="405.95"
					y2="64.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.95"
					y1="64.61"
					x2="405.97"
					y2="64.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.34"
					y1="71.95"
					x2="407.59"
					y2="69.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.85"
					y1="64.7"
					x2="447.6"
					y2="66.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="451.63 72.17 447.34 71.95 447.6 66.71 451.9 66.92 451.63 72.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="451.63"
					y1="72.17"
					x2="447.34"
					y2="71.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.34"
					y1="71.95"
					x2="447.6"
					y2="66.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.6"
					y1="66.71"
					x2="451.9"
					y2="66.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.9"
					y1="66.92"
					x2="451.63"
					y2="72.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="403.56 64.49 407.85 64.7 407.59 69.95 403.3 69.73 403.56 64.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="403.56"
					y1="64.49"
					x2="407.85"
					y2="64.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.85"
					y1="64.7"
					x2="407.59"
					y2="69.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.59"
					y1="69.95"
					x2="403.3"
					y2="69.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.3"
					y1="69.73"
					x2="403.56"
					y2="64.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.55"
					y1="67.66"
					x2="407.81"
					y2="65.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="453.56 71.79 451.65 71.69 451.9 66.92 449.51 66.8 449.53 66.32 453.83 66.54 453.56 71.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="453.56"
					y1="71.79"
					x2="451.65"
					y2="71.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.65"
					y1="71.69"
					x2="451.9"
					y2="66.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.9"
					y1="66.92"
					x2="449.51"
					y2="66.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.51"
					y1="66.8"
					x2="449.53"
					y2="66.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.53"
					y1="66.32"
					x2="453.83"
					y2="66.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.83"
					y1="66.54"
					x2="453.56"
					y2="71.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="401.68 63.91 405.97 64.13 405.95 64.61 403.56 64.49 403.32 69.26 401.41 69.16 401.68 63.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="401.68"
					y1="63.91"
					x2="405.97"
					y2="64.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.97"
					y1="64.13"
					x2="405.95"
					y2="64.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.95"
					y1="64.61"
					x2="403.56"
					y2="64.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.56"
					y1="64.49"
					x2="403.32"
					y2="69.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.32"
					y1="69.26"
					x2="401.41"
					y2="69.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.41"
					y1="69.16"
					x2="401.68"
					y2="63.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="396.75 65.1 401.6 65.34 400.87 79.89 396.02 79.64 396.75 65.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="401.6"
					y1="65.34"
					x2="396.75"
					y2="65.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.87"
					y1="79.89"
					x2="401.6"
					y2="65.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.02"
					y1="79.64"
					x2="400.87"
					y2="79.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.75"
					y1="65.1"
					x2="396.02"
					y2="79.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="458.61 68.22 457.87 82.76 453.02 82.52 453.76 67.97 458.61 68.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="457.87"
					y1="82.76"
					x2="458.61"
					y2="68.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.02"
					y1="82.52"
					x2="457.87"
					y2="82.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.76"
					y1="67.97"
					x2="453.02"
					y2="82.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.61"
					y1="68.22"
					x2="453.76"
					y2="67.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="268.81 58.65 273.66 58.89 272.93 73.44 268.08 73.19 268.81 58.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="273.66"
					y1="58.89"
					x2="268.81"
					y2="58.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.93"
					y1="73.44"
					x2="273.66"
					y2="58.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.08"
					y1="73.19"
					x2="272.93"
					y2="73.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.81"
					y1="58.65"
					x2="268.08"
					y2="73.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="692.04 79.99 691.91 82.41 592.45 77.4 592.57 74.97 692.04 79.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="692.04"
					y1="79.99"
					x2="691.91"
					y2="82.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.91"
					y1="82.41"
					x2="592.45"
					y2="77.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.45"
					y1="77.4"
					x2="592.57"
					y2="74.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.57"
					y1="74.97"
					x2="692.04"
					y2="79.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="740.41 81.47 700.71 79.47 700.45 84.72 740.14 86.72 740.41 81.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="698.83 78.9 742.34 81.09 742.32 81.57 698.8 79.37 698.83 78.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="698.83"
					y1="78.9"
					x2="742.34"
					y2="81.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.34"
					y1="81.09"
					x2="742.32"
					y2="81.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.32"
					y1="81.57"
					x2="698.8"
					y2="79.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.8"
					y1="79.37"
					x2="698.83"
					y2="78.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.14"
					y1="86.72"
					x2="700.45"
					y2="84.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.71"
					y1="79.47"
					x2="740.41"
					y2="81.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="744.44 86.94 740.14 86.72 740.41 81.47 744.7 81.69 744.44 86.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="744.44"
					y1="86.94"
					x2="740.14"
					y2="86.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.14"
					y1="86.72"
					x2="740.41"
					y2="81.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.41"
					y1="81.47"
					x2="744.7"
					y2="81.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.7"
					y1="81.69"
					x2="744.44"
					y2="86.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="696.42 79.25 700.71 79.47 700.45 84.72 696.15 84.5 696.42 79.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="696.42"
					y1="79.25"
					x2="700.71"
					y2="79.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.71"
					y1="79.47"
					x2="700.45"
					y2="84.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.45"
					y1="84.72"
					x2="696.15"
					y2="84.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.15"
					y1="84.5"
					x2="696.42"
					y2="79.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.36"
					y1="82.42"
					x2="700.67"
					y2="80.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="746.37 86.55 744.46 86.46 744.7 81.69 742.32 81.57 742.34 81.09 746.63 81.31 746.37 86.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="746.37"
					y1="86.55"
					x2="744.46"
					y2="86.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.46"
					y1="86.46"
					x2="744.7"
					y2="81.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.7"
					y1="81.69"
					x2="742.32"
					y2="81.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.32"
					y1="81.57"
					x2="742.34"
					y2="81.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.34"
					y1="81.09"
					x2="746.63"
					y2="81.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.63"
					y1="81.31"
					x2="746.37"
					y2="86.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="694.53 78.68 698.83 78.9 698.8 79.37 696.42 79.25 696.18 84.02 694.27 83.93 694.53 78.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="694.53"
					y1="78.68"
					x2="698.83"
					y2="78.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.83"
					y1="78.9"
					x2="698.8"
					y2="79.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.8"
					y1="79.37"
					x2="696.42"
					y2="79.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.42"
					y1="79.25"
					x2="696.18"
					y2="84.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.18"
					y1="84.02"
					x2="694.27"
					y2="83.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.27"
					y1="83.93"
					x2="694.53"
					y2="78.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="689.61 79.87 694.46 80.11 693.73 94.65 688.88 94.41 689.61 79.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="694.46"
					y1="80.11"
					x2="689.61"
					y2="79.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.73"
					y1="94.65"
					x2="694.46"
					y2="80.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.88"
					y1="94.41"
					x2="693.73"
					y2="94.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.61"
					y1="79.87"
					x2="688.88"
					y2="94.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="751.41 82.98 750.68 97.53 745.83 97.28 746.56 82.74 751.41 82.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="750.68"
					y1="97.53"
					x2="751.41"
					y2="82.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.83"
					y1="97.28"
					x2="750.68"
					y2="97.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.56"
					y1="82.74"
					x2="745.83"
					y2="97.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.41"
					y1="82.98"
					x2="746.56"
					y2="82.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="590.15 74.85 595 75.09 594.26 89.64 589.41 89.39 590.15 74.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="595"
					y1="75.09"
					x2="590.15"
					y2="74.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.26"
					y1="89.64"
					x2="595"
					y2="75.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.41"
					y1="89.39"
					x2="594.26"
					y2="89.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.15"
					y1="74.85"
					x2="589.41"
					y2="89.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.3"
					y1="776.96"
					x2="761.3"
					y2="757.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="695.05"
					y1="580.87"
					x2="695.05"
					y2="664.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="695.05"
					y1="690.64"
					x2="695.05"
					y2="683.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="695.05"
					y1="676.56"
					x2="695.05"
					y2="683.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="751.66"
					y1="78.13"
					x2="750.68"
					y2="97.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="223.79"
					y1="713.44"
					x2="223.79"
					y2="626.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="599.38"
					y1="940.07"
					x2="603.02"
					y2="940.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="600.31"
					y1="920.68"
					x2="603.95"
					y2="920.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="600.31"
					y1="920.68"
					x2="599.38"
					y2="940.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.26"
					y1="935.65"
					x2="503.62"
					y2="935.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="508.19"
					y1="916.25"
					x2="504.56"
					y2="916.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="508.19"
					y1="916.25"
					x2="507.26"
					y2="935.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="920.92"
					x2="600.31"
					y2="920.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="508.42 936.92 508.47 935.71 503.62 935.47 503.57 936.68 508.42 936.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="598.17 940.01 598.11 941.22 602.96 941.46 603.02 940.24 598.17 940.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="509.41 916.31 509.46 915.1 504.61 914.87 504.56 916.08 509.41 916.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="599.16 919.41 599.1 920.62 603.95 920.85 604.01 919.64 599.16 919.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="508.42"
					y1="936.92"
					x2="503.57"
					y2="936.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.57"
					y1="936.68"
					x2="503.62"
					y2="935.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.62"
					y1="935.47"
					x2="508.47"
					y2="935.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.47"
					y1="935.71"
					x2="508.42"
					y2="936.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.17"
					y1="940.01"
					x2="603.02"
					y2="940.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.02"
					y1="940.24"
					x2="602.96"
					y2="941.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.96"
					y1="941.46"
					x2="598.11"
					y2="941.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.11"
					y1="941.22"
					x2="598.17"
					y2="940.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.41"
					y1="916.31"
					x2="504.56"
					y2="916.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.56"
					y1="916.08"
					x2="504.61"
					y2="914.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.61"
					y1="914.87"
					x2="509.46"
					y2="915.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.46"
					y1="915.1"
					x2="509.41"
					y2="916.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.16"
					y1="919.41"
					x2="604.01"
					y2="919.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.01"
					y1="919.64"
					x2="603.95"
					y2="920.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.95"
					y1="920.85"
					x2="599.1"
					y2="920.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.1"
					y1="920.62"
					x2="599.16"
					y2="919.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="509.69 935.76 510.62 916.37 508.8 916.28 507.87 935.68 509.69 935.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="598.78 940.04 599.71 920.65 597.89 920.56 596.96 939.95 598.78 940.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="539.14 855.89 536 858.74 594.74 923.42 597.89 920.56 539.14 855.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="508.8"
					y1="916.28"
					x2="508.19"
					y2="916.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.87"
					y1="935.68"
					x2="507.26"
					y2="935.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.19"
					y1="916.25"
					x2="507.26"
					y2="935.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.71"
					y1="920.65"
					x2="600.31"
					y2="920.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.78"
					y1="940.04"
					x2="599.38"
					y2="940.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.31"
					y1="920.68"
					x2="599.38"
					y2="940.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.69"
					y1="935.76"
					x2="510.62"
					y2="916.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.62"
					y1="916.37"
					x2="508.8"
					y2="916.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.8"
					y1="916.28"
					x2="507.87"
					y2="935.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.87"
					y1="935.68"
					x2="509.69"
					y2="935.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.78"
					y1="940.04"
					x2="599.71"
					y2="920.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.71"
					y1="920.65"
					x2="597.89"
					y2="920.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.89"
					y1="920.56"
					x2="596.96"
					y2="939.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.96"
					y1="939.95"
					x2="598.78"
					y2="940.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.14"
					y1="855.89"
					x2="536"
					y2="858.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536"
					y1="858.74"
					x2="594.74"
					y2="923.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.74"
					y1="923.42"
					x2="597.89"
					y2="920.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.89"
					y1="920.56"
					x2="539.14"
					y2="855.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.19"
					y1="916.25"
					x2="507.26"
					y2="935.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="508.19"
					y1="916.25"
					x2="507.26"
					y2="935.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="508.19"
					y1="916.25"
					x2="504.56"
					y2="916.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="508.19"
					y1="916.25"
					x2="504.56"
					y2="916.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.26"
					y1="935.65"
					x2="503.62"
					y2="935.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="507.26"
					y1="935.65"
					x2="503.62"
					y2="935.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="600.31"
					y1="920.68"
					x2="599.38"
					y2="940.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="600.31"
					y1="920.68"
					x2="599.38"
					y2="940.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="600.31"
					y1="920.68"
					x2="603.95"
					y2="920.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="600.31"
					y1="920.68"
					x2="603.95"
					y2="920.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="599.38"
					y1="940.07"
					x2="603.02"
					y2="940.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="599.38"
					y1="940.07"
					x2="603.02"
					y2="940.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="910.65"
					x2="605.39"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="910.65"
					x2="617.53"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="910.65"
					x2="605.39"
					y2="910.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="823.28"
					x2="605.39"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="823.28"
					x2="617.53"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="823.28"
					x2="605.39"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="592.73"
					x2="617.53"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="592.73"
					x2="605.39"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="592.73"
					x2="617.53"
					y2="592.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="660.69"
					x2="617.53"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="660.69"
					x2="605.39"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="660.69"
					x2="617.53"
					y2="660.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="664.42"
					x2="617.53"
					y2="660.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="573.93"
					x2="605.39"
					y2="592.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="910.65"
					x2="605.39"
					y2="920.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="604.18 824.49 605.39 824.49 605.39 819.64 604.18 819.64 604.18 824.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="605.39 909.44 604.18 909.44 604.18 914.29 605.39 914.29 605.39 909.44"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="617.53 824.49 618.74 824.49 618.74 819.64 617.53 819.64 617.53 824.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="618.74 909.44 617.53 909.44 617.53 914.29 618.74 914.29 618.74 909.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="604.18"
					y1="824.49"
					x2="604.18"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.18"
					y1="819.64"
					x2="605.39"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="819.64"
					x2="605.39"
					y2="824.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="824.49"
					x2="604.18"
					y2="824.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="909.44"
					x2="605.39"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="914.29"
					x2="604.18"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.18"
					y1="914.29"
					x2="604.18"
					y2="909.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.18"
					y1="909.44"
					x2="605.39"
					y2="909.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="824.49"
					x2="617.53"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="819.64"
					x2="618.74"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.74"
					y1="819.64"
					x2="618.74"
					y2="824.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.74"
					y1="824.49"
					x2="617.53"
					y2="824.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.74"
					y1="909.44"
					x2="618.74"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.74"
					y1="914.29"
					x2="617.53"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="914.29"
					x2="617.53"
					y2="909.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="909.44"
					x2="618.74"
					y2="909.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="605.39 825.71 617.53 825.71 617.53 823.89 605.39 823.89 605.39 825.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="605.39 910.05 617.53 910.05 617.53 908.22 605.39 908.22 605.39 910.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="675.87 849.88 672.87 846.88 614.52 905.22 617.53 908.22 675.87 849.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="617.53"
					y1="823.89"
					x2="617.53"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="823.89"
					x2="605.39"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="823.28"
					x2="605.39"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="910.05"
					x2="617.53"
					y2="910.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="910.05"
					x2="605.39"
					y2="910.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="910.65"
					x2="605.39"
					y2="910.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="825.71"
					x2="617.53"
					y2="825.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="825.71"
					x2="617.53"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="823.89"
					x2="605.39"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="823.89"
					x2="605.39"
					y2="825.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="910.05"
					x2="617.53"
					y2="910.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="910.05"
					x2="617.53"
					y2="908.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="908.22"
					x2="605.39"
					y2="908.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="908.22"
					x2="605.39"
					y2="910.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.87"
					y1="849.88"
					x2="672.87"
					y2="846.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.87"
					y1="846.88"
					x2="614.52"
					y2="905.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.52"
					y1="905.22"
					x2="617.53"
					y2="908.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="908.22"
					x2="675.87"
					y2="849.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="823.28"
					x2="605.39"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="823.28"
					x2="605.39"
					y2="823.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="823.28"
					x2="617.53"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="823.28"
					x2="617.53"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="823.28"
					x2="605.39"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="823.28"
					x2="605.39"
					y2="819.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="910.65"
					x2="605.39"
					y2="910.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="910.65"
					x2="605.39"
					y2="910.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="910.65"
					x2="617.53"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="910.65"
					x2="617.53"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="910.65"
					x2="605.39"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="910.65"
					x2="605.39"
					y2="914.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="618.74 659.47 617.53 659.47 617.53 664.33 618.74 664.33 618.74 659.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="617.53 593.95 618.74 593.95 618.74 589.09 617.53 589.09 617.53 593.95"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="605.39 659.47 604.18 659.47 604.18 664.33 605.39 664.33 605.39 659.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="604.18 593.95 605.39 593.95 605.39 589.09 604.18 589.09 604.18 593.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="618.74"
					y1="659.47"
					x2="618.74"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.74"
					y1="664.33"
					x2="617.53"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="664.33"
					x2="617.53"
					y2="659.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="659.47"
					x2="618.74"
					y2="659.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="593.95"
					x2="617.53"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="589.09"
					x2="618.74"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.74"
					y1="589.09"
					x2="618.74"
					y2="593.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.74"
					y1="593.95"
					x2="617.53"
					y2="593.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="659.47"
					x2="605.39"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="664.33"
					x2="604.18"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.18"
					y1="664.33"
					x2="604.18"
					y2="659.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.18"
					y1="659.47"
					x2="605.39"
					y2="659.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.18"
					y1="593.95"
					x2="604.18"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.18"
					y1="589.09"
					x2="605.39"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="589.09"
					x2="605.39"
					y2="593.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="593.95"
					x2="604.18"
					y2="593.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="617.53 658.26 605.39 658.26 605.39 660.08 617.53 660.08 617.53 658.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="617.53 593.34 605.39 593.34 605.39 595.16 617.53 595.16 617.53 593.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="560.77 639.78 563.77 642.78 608.39 598.16 605.39 595.16 560.77 639.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="605.39"
					y1="660.08"
					x2="605.39"
					y2="660.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="660.08"
					x2="617.53"
					y2="660.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="660.69"
					x2="617.53"
					y2="660.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="593.34"
					x2="605.39"
					y2="592.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="593.34"
					x2="617.53"
					y2="592.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="592.73"
					x2="617.53"
					y2="592.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="658.26"
					x2="605.39"
					y2="658.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="658.26"
					x2="605.39"
					y2="660.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="660.08"
					x2="617.53"
					y2="660.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="660.08"
					x2="617.53"
					y2="658.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="593.34"
					x2="605.39"
					y2="593.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="593.34"
					x2="605.39"
					y2="595.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="595.16"
					x2="617.53"
					y2="595.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="595.16"
					x2="617.53"
					y2="593.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.77"
					y1="639.78"
					x2="563.77"
					y2="642.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.77"
					y1="642.78"
					x2="608.39"
					y2="598.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.39"
					y1="598.16"
					x2="605.39"
					y2="595.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="595.16"
					x2="560.77"
					y2="639.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.39"
					y1="660.69"
					x2="617.53"
					y2="660.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="660.69"
					x2="617.53"
					y2="660.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="660.69"
					x2="605.39"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="660.69"
					x2="605.39"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="660.69"
					x2="617.53"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="660.69"
					x2="617.53"
					y2="664.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="592.73"
					x2="617.53"
					y2="592.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="592.73"
					x2="617.53"
					y2="592.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="592.73"
					x2="605.39"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="605.39"
					y1="592.73"
					x2="605.39"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="592.73"
					x2="617.53"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="617.53"
					y1="592.73"
					x2="617.53"
					y2="589.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="633.07"
					y1="580.87"
					x2="695.05"
					y2="580.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="656.9"
					y1="422.88"
					x2="656.9"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="744.27"
					y1="410.75"
					x2="747.91"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="744.27"
					y1="422.88"
					x2="747.91"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="744.27"
					y1="422.88"
					x2="744.27"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="743.06 409.54 743.06 410.75 747.91 410.75 747.91 409.54 743.06 409.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="743.06 422.88 743.06 424.1 747.91 424.1 747.91 422.88 743.06 422.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="743.06"
					y1="409.54"
					x2="747.91"
					y2="409.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="409.54"
					x2="747.91"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="410.75"
					x2="743.06"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.06"
					y1="410.75"
					x2="743.06"
					y2="409.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.11"
					y1="409.54"
					x2="658.11"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.06"
					y1="422.88"
					x2="747.91"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="422.88"
					x2="747.91"
					y2="424.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="424.1"
					x2="743.06"
					y2="424.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.06"
					y1="424.1"
					x2="743.06"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.11"
					y1="422.88"
					x2="658.11"
					y2="424.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="741.85 410.75 741.85 422.88 743.67 422.88 743.67 410.75 741.85 410.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="657.51 410.75 657.51 422.88 659.33 422.88 659.33 410.75 657.51 410.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="717.68 481.23 720.68 478.23 662.33 419.88 659.33 422.88 717.68 481.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="743.67"
					y1="422.88"
					x2="744.27"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.67"
					y1="410.75"
					x2="744.27"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.27"
					y1="422.88"
					x2="744.27"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.51"
					y1="422.88"
					x2="656.9"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.51"
					y1="410.75"
					x2="656.9"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.9"
					y1="422.88"
					x2="656.9"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.85"
					y1="410.75"
					x2="741.85"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.85"
					y1="422.88"
					x2="743.67"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.67"
					y1="422.88"
					x2="743.67"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.67"
					y1="410.75"
					x2="741.85"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.51"
					y1="410.75"
					x2="657.51"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.51"
					y1="422.88"
					x2="659.33"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.33"
					y1="422.88"
					x2="659.33"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.33"
					y1="410.75"
					x2="657.51"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.68"
					y1="481.23"
					x2="720.68"
					y2="478.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.68"
					y1="478.23"
					x2="662.33"
					y2="419.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.33"
					y1="419.88"
					x2="659.33"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.33"
					y1="422.88"
					x2="717.68"
					y2="481.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.27"
					y1="422.88"
					x2="744.27"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="744.27"
					y1="422.88"
					x2="744.27"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="744.27"
					y1="422.88"
					x2="747.91"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="744.27"
					y1="422.88"
					x2="747.91"
					y2="422.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="744.27"
					y1="410.75"
					x2="747.91"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="744.27"
					y1="410.75"
					x2="747.91"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="656.9"
					y1="422.88"
					x2="656.9"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="656.9"
					y1="422.88"
					x2="656.9"
					y2="410.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.43"
					y1="480.38"
					x2="504.43"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="480.38"
					x2="516.56"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="480.38"
					x2="504.43"
					y2="480.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.43"
					y1="393.01"
					x2="504.43"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="393.01"
					x2="516.56"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="393.01"
					x2="504.43"
					y2="393.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="503.21 394.22 504.43 394.22 504.43 389.37 503.21 389.37 503.21 394.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="504.43 479.17 503.21 479.17 503.21 484.02 504.43 484.02 504.43 479.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="516.56 394.22 517.78 394.22 517.78 389.37 516.56 389.37 516.56 394.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="517.78 479.17 516.56 479.17 516.56 484.02 517.78 484.02 517.78 479.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="503.21"
					y1="394.22"
					x2="503.21"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.21"
					y1="389.37"
					x2="504.43"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="389.37"
					x2="504.43"
					y2="394.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="394.22"
					x2="503.21"
					y2="394.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="479.17"
					x2="504.43"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="484.02"
					x2="503.21"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.21"
					y1="484.02"
					x2="503.21"
					y2="479.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.21"
					y1="479.17"
					x2="504.43"
					y2="479.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="394.22"
					x2="516.56"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="389.37"
					x2="517.78"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.78"
					y1="389.37"
					x2="517.78"
					y2="394.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.78"
					y1="394.22"
					x2="516.56"
					y2="394.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.78"
					y1="479.17"
					x2="517.78"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.78"
					y1="484.02"
					x2="516.56"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="484.02"
					x2="516.56"
					y2="479.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="479.17"
					x2="517.78"
					y2="479.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="504.43 395.44 516.56 395.44 516.56 393.62 504.43 393.62 504.43 395.44"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="504.43 479.78 516.56 479.78 516.56 477.96 504.43 477.96 504.43 479.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="574.91 419.61 571.91 416.61 513.56 474.95 516.56 477.96 574.91 419.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="516.56"
					y1="393.62"
					x2="516.56"
					y2="393.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="393.62"
					x2="504.43"
					y2="393.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="393.01"
					x2="504.43"
					y2="393.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="479.78"
					x2="516.56"
					y2="480.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="479.78"
					x2="504.43"
					y2="480.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="480.38"
					x2="504.43"
					y2="480.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="395.44"
					x2="516.56"
					y2="395.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="395.44"
					x2="516.56"
					y2="393.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="393.62"
					x2="504.43"
					y2="393.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="393.62"
					x2="504.43"
					y2="395.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="479.78"
					x2="516.56"
					y2="479.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="479.78"
					x2="516.56"
					y2="477.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="477.96"
					x2="504.43"
					y2="477.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.43"
					y1="477.96"
					x2="504.43"
					y2="479.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.91"
					y1="419.61"
					x2="571.91"
					y2="416.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.91"
					y1="416.61"
					x2="513.56"
					y2="474.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.56"
					y1="474.95"
					x2="516.56"
					y2="477.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="477.96"
					x2="574.91"
					y2="419.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.56"
					y1="393.01"
					x2="504.43"
					y2="393.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="393.01"
					x2="504.43"
					y2="393.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="393.01"
					x2="516.56"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="393.01"
					x2="516.56"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.43"
					y1="393.01"
					x2="504.43"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.43"
					y1="393.01"
					x2="504.43"
					y2="389.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="480.38"
					x2="504.43"
					y2="480.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="480.38"
					x2="504.43"
					y2="480.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="480.38"
					x2="516.56"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="516.56"
					y1="480.38"
					x2="516.56"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.43"
					y1="480.38"
					x2="504.43"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.43"
					y1="480.38"
					x2="504.43"
					y2="484.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="561.79"
					x2="600.98"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="573.93"
					x2="600.98"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="573.93"
					x2="597.34"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.38"
					y1="561.79"
					x2="525.74"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.38"
					y1="573.93"
					x2="525.74"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.38"
					y1="573.93"
					x2="529.38"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="573.93"
					x2="605.39"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="530.6 560.58 525.74 560.58 525.74 561.79 530.6 561.79 530.6 560.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.13 561.79 600.98 561.79 600.98 560.58 596.13 560.58 596.13 561.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="530.6 573.93 525.74 573.93 525.74 575.14 530.6 575.14 530.6 573.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.13 575.14 600.98 575.14 600.98 573.93 596.13 573.93 596.13 575.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="530.6"
					y1="560.58"
					x2="525.74"
					y2="560.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.74"
					y1="560.58"
					x2="525.74"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.74"
					y1="561.79"
					x2="530.6"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.6"
					y1="561.79"
					x2="530.6"
					y2="560.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.13"
					y1="561.79"
					x2="600.98"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.98"
					y1="561.79"
					x2="600.98"
					y2="560.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.98"
					y1="560.58"
					x2="596.13"
					y2="560.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.13"
					y1="560.58"
					x2="596.13"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.6"
					y1="573.93"
					x2="525.74"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.74"
					y1="573.93"
					x2="525.74"
					y2="575.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.74"
					y1="575.14"
					x2="530.6"
					y2="575.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.6"
					y1="575.14"
					x2="530.6"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.13"
					y1="575.14"
					x2="600.98"
					y2="575.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.98"
					y1="575.14"
					x2="600.98"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.98"
					y1="573.93"
					x2="596.13"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.13"
					y1="573.93"
					x2="596.13"
					y2="575.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="531.81 561.79 529.99 561.79 529.99 573.93 531.81 573.93 531.81 561.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.73 561.79 594.91 561.79 594.91 573.93 596.73 573.93 596.73 561.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="550.29 618.55 594.91 573.93 591.91 570.92 547.29 615.54 550.29 618.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="529.99"
					y1="573.93"
					x2="529.38"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.99"
					y1="561.79"
					x2="529.38"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.38"
					y1="573.93"
					x2="529.38"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.73"
					y1="573.93"
					x2="597.34"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.73"
					y1="561.79"
					x2="597.34"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.34"
					y1="573.93"
					x2="597.34"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.81"
					y1="561.79"
					x2="531.81"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.81"
					y1="573.93"
					x2="529.99"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.99"
					y1="573.93"
					x2="529.99"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.99"
					y1="561.79"
					x2="531.81"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.73"
					y1="561.79"
					x2="596.73"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.73"
					y1="573.93"
					x2="594.91"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.91"
					y1="573.93"
					x2="594.91"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.91"
					y1="561.79"
					x2="596.73"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.29"
					y1="618.55"
					x2="547.29"
					y2="615.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.29"
					y1="615.54"
					x2="591.91"
					y2="570.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.91"
					y1="570.92"
					x2="594.91"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.91"
					y1="573.93"
					x2="550.29"
					y2="618.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.38"
					y1="573.93"
					x2="529.38"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.38"
					y1="573.93"
					x2="529.38"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.38"
					y1="573.93"
					x2="525.74"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.38"
					y1="573.93"
					x2="525.74"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.38"
					y1="561.79"
					x2="525.74"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="529.38"
					y1="561.79"
					x2="525.74"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="573.93"
					x2="597.34"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="573.93"
					x2="597.34"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="573.93"
					x2="600.98"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="573.93"
					x2="600.98"
					y2="573.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="561.79"
					x2="600.98"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="597.34"
					y1="561.79"
					x2="600.98"
					y2="561.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="695.05"
					y1="664.42"
					x2="617.53"
					y2="664.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.75"
					y1="894.11"
					x2="383.75"
					y2="873.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.75"
					y1="873.23"
					x2="371.61"
					y2="873.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="371.61"
					y1="873.23"
					x2="213.13"
					y2="873.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="269.06"
					y1="53.8"
					x2="268.08"
					y2="73.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="458.85"
					y1="63.37"
					x2="457.87"
					y2="82.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="589.41"
					y1="89.39"
					x2="590.39"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="465.12"
					y1="894.11"
					x2="452.98"
					y2="894.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="452.98"
					y1="894.11"
					x2="383.75"
					y2="894.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="718.05 877.4 716.12 881.73 715.45 886.43 716.12 891.12 718.05 895.45 720.5 898.31 723.58 900.47 730.81 903.22 736.8 904.19 742.87 903.83 748.71 902.15 756.67 902.81 763.94 906.14 765.99 907.44 770.21 908.98 774.69 908.75 776.46 908.05 781.17 908.05 781.17 906.09 779.03 906.09 781.01 902.8 781.79 899.04 781.79 873.82 780.48 868.95 777 865.29 772.21 863.72 771.63 863.72 768.6 864.22 763.83 866.78 756.65 870.08 748.77 870.73 742.91 869.04 736.83 868.66 730.81 869.63 723.58 872.38 720.5 874.55 718.05 877.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="759.38"
					y1="895.41"
					x2="759.38"
					y2="877.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.79"
					y1="873.82"
					x2="781.79"
					y2="886.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.88"
					y1="873.82"
					x2="780.88"
					y2="886.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.79"
					y1="899.04"
					x2="781.79"
					y2="886.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.88"
					y1="899.04"
					x2="780.88"
					y2="886.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.38"
					y1="877.91"
					x2="762.73"
					y2="877.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.73"
					y1="877.91"
					x2="762.73"
					y2="880.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.73"
					y1="880.69"
					x2="759.38"
					y2="880.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.38"
					y1="894.95"
					x2="762.73"
					y2="894.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.73"
					y1="894.95"
					x2="762.73"
					y2="892.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.73"
					y1="892.17"
					x2="759.38"
					y2="892.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.83"
					y1="906.09"
					x2="781.17"
					y2="906.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.83"
					y1="908.05"
					x2="781.17"
					y2="908.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.17"
					y1="908.05"
					x2="781.17"
					y2="906.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.83"
					y1="908.05"
					x2="772.83"
					y2="906.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.45"
					y1="886.43"
					x2="715.8"
					y2="883.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.8"
					y1="883.42"
					x2="716.57"
					y2="880.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.57"
					y1="880.5"
					x2="718.05"
					y2="877.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.05"
					y1="877.4"
					x2="720.5"
					y2="874.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.5"
					y1="874.55"
					x2="723.58"
					y2="872.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.58"
					y1="872.38"
					x2="727.09"
					y2="870.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.09"
					y1="870.79"
					x2="730.81"
					y2="869.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.81"
					y1="869.63"
					x2="736.82"
					y2="868.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.82"
					y1="868.58"
					x2="739.85"
					y2="868.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.85"
					y1="868.53"
					x2="742.86"
					y2="868.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.86"
					y1="868.87"
					x2="747.55"
					y2="870.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.55"
					y1="870.24"
					x2="752.09"
					y2="872.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.09"
					y1="872.36"
					x2="756.14"
					y2="874.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.14"
					y1="874.88"
					x2="759.38"
					y2="877.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.77"
					y1="870.73"
					x2="752.98"
					y2="870.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.98"
					y1="870.71"
					x2="757.07"
					y2="870.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.07"
					y1="870.01"
					x2="759.27"
					y2="869.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.27"
					y1="869.3"
					x2="761.46"
					y2="868.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.46"
					y1="868.27"
					x2="764.64"
					y2="866.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.64"
					y1="866.25"
					x2="767.93"
					y2="864.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.93"
					y1="864.46"
					x2="771.14"
					y2="863.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.14"
					y1="863.74"
					x2="774.34"
					y2="864.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.34"
					y1="864.01"
					x2="777.25"
					y2="865.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.25"
					y1="865.26"
					x2="778.51"
					y2="866.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.51"
					y1="866.24"
					x2="779.59"
					y2="867.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.59"
					y1="867.47"
					x2="780.78"
					y2="869.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.78"
					y1="869.61"
					x2="781.45"
					y2="871.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.45"
					y1="871.67"
					x2="781.79"
					y2="873.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.88"
					y1="873.82"
					x2="780.79"
					y2="872.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.79"
					y1="872.86"
					x2="780.17"
					y2="870.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.17"
					y1="870.88"
					x2="778.7"
					y2="869.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.7"
					y1="869.13"
					x2="776.64"
					y2="868.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.64"
					y1="868.03"
					x2="773.94"
					y2="867.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.94"
					y1="867.51"
					x2="771.15"
					y2="867.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.15"
					y1="867.39"
					x2="769.76"
					y2="867.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.76"
					y1="867.41"
					x2="768.66"
					y2="867.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.66"
					y1="867.99"
					x2="768.34"
					y2="868.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.34"
					y1="868.67"
					x2="766.18"
					y2="876.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.18"
					y1="876.3"
					x2="765.53"
					y2="880.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.53"
					y1="880.09"
					x2="765.25"
					y2="883.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.25"
					y1="883.92"
					x2="765.25"
					y2="886.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.71"
					y1="902.15"
					x2="752.93"
					y2="902.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.93"
					y1="902.18"
					x2="757.04"
					y2="902.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.04"
					y1="902.87"
					x2="759.26"
					y2="903.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.26"
					y1="903.57"
					x2="761.46"
					y2="904.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.46"
					y1="904.58"
					x2="764.64"
					y2="906.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.64"
					y1="906.6"
					x2="767.93"
					y2="908.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.93"
					y1="908.4"
					x2="770.07"
					y2="908.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.07"
					y1="908.99"
					x2="772.28"
					y2="909.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.28"
					y1="909.13"
					x2="774.44"
					y2="908.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.44"
					y1="908.82"
					x2="776.46"
					y2="908.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.88"
					y1="899.04"
					x2="780.79"
					y2="900"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.79"
					y1="900"
					x2="780.17"
					y2="901.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.17"
					y1="901.98"
					x2="778.7"
					y2="903.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.7"
					y1="903.73"
					x2="776.64"
					y2="904.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.64"
					y1="904.83"
					x2="773.94"
					y2="905.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.94"
					y1="905.35"
					x2="771.15"
					y2="905.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.15"
					y1="905.47"
					x2="769.76"
					y2="905.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.76"
					y1="905.45"
					x2="768.66"
					y2="904.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.66"
					y1="904.87"
					x2="768.34"
					y2="904.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.34"
					y1="904.18"
					x2="766.18"
					y2="896.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.18"
					y1="896.56"
					x2="765.53"
					y2="892.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.53"
					y1="892.77"
					x2="765.25"
					y2="888.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.25"
					y1="888.93"
					x2="765.25"
					y2="886.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.45"
					y1="886.43"
					x2="715.8"
					y2="889.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.8"
					y1="889.44"
					x2="716.57"
					y2="892.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.57"
					y1="892.35"
					x2="718.05"
					y2="895.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.05"
					y1="895.45"
					x2="720.5"
					y2="898.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.5"
					y1="898.31"
					x2="723.58"
					y2="900.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.58"
					y1="900.47"
					x2="727.09"
					y2="902.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.09"
					y1="902.07"
					x2="730.81"
					y2="903.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.81"
					y1="903.22"
					x2="736.82"
					y2="904.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.82"
					y1="904.27"
					x2="739.85"
					y2="904.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.85"
					y1="904.33"
					x2="742.86"
					y2="903.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.86"
					y1="903.99"
					x2="747.55"
					y2="902.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.55"
					y1="902.62"
					x2="752.09"
					y2="900.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.09"
					y1="900.5"
					x2="756.14"
					y2="897.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.14"
					y1="897.97"
					x2="759.38"
					y2="895.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.18"
					y1="865.3"
					x2="765.49"
					y2="865.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.49"
					y1="865.78"
					x2="764.47"
					y2="867.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="867.17"
					x2="764.23"
					y2="868.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.23"
					y1="868.38"
					x2="763.57"
					y2="876.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.57"
					y1="876.12"
					x2="763.26"
					y2="883.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.26"
					y1="883.89"
					x2="763.26"
					y2="886.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.18"
					y1="907.56"
					x2="765.49"
					y2="907.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.49"
					y1="907.07"
					x2="764.47"
					y2="905.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.47"
					y1="905.69"
					x2="764.23"
					y2="904.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.23"
					y1="904.48"
					x2="763.57"
					y2="896.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.57"
					y1="896.74"
					x2="763.26"
					y2="888.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.26"
					y1="888.97"
					x2="763.26"
					y2="886.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.03"
					y1="906.09"
					x2="779.59"
					y2="905.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.59"
					y1="905.39"
					x2="780.78"
					y2="903.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.78"
					y1="903.24"
					x2="781.45"
					y2="901.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.45"
					y1="901.18"
					x2="781.79"
					y2="899.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="781.79 857.3 780.82 857.3 780.82 862.16 781.79 862.16 781.79 857.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="781.79"
					y1="862.16"
					x2="781.79"
					y2="857.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.82"
					y1="862.16"
					x2="781.79"
					y2="862.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.82"
					y1="857.3"
					x2="780.82"
					y2="862.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.79"
					y1="857.3"
					x2="780.82"
					y2="857.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="781.79 915.55 781.79 910.7 780.82 910.7 780.82 915.55 781.79 915.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="780.82"
					y1="915.55"
					x2="781.79"
					y2="915.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.82"
					y1="910.7"
					x2="780.82"
					y2="915.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.79"
					y1="910.7"
					x2="780.82"
					y2="910.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.79"
					y1="915.55"
					x2="781.79"
					y2="910.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="780.82 859.25 772.92 859.25 772.92 860.22 780.82 860.22 780.82 859.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="780.82"
					y1="860.22"
					x2="780.82"
					y2="859.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.92"
					y1="860.22"
					x2="780.82"
					y2="860.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.92"
					y1="859.25"
					x2="772.92"
					y2="860.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.82"
					y1="859.25"
					x2="772.92"
					y2="859.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="780.82 913.61 780.82 912.64 772.92 912.64 772.92 913.61 780.82 913.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.92"
					y1="913.61"
					x2="780.82"
					y2="913.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.92"
					y1="912.64"
					x2="772.92"
					y2="913.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.82"
					y1="912.64"
					x2="772.92"
					y2="912.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.82"
					y1="913.61"
					x2="780.82"
					y2="912.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="775.35 860.22 773.41 860.22 773.41 912.64 775.35 912.64 775.35 860.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="775.35"
					y1="912.64"
					x2="775.35"
					y2="860.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.41"
					y1="912.64"
					x2="775.35"
					y2="912.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.41"
					y1="860.22"
					x2="773.41"
					y2="912.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.35"
					y1="860.22"
					x2="773.41"
					y2="860.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="776.96"
					x2="761.3"
					y2="776.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="752.3 768.17 752.3 712.53 627.15 712.53 627.15 768.17 752.3 768.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="627.15"
					y1="768.17"
					x2="752.3"
					y2="768.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.15"
					y1="712.53"
					x2="627.15"
					y2="768.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.3"
					y1="712.53"
					x2="627.15"
					y2="712.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.3"
					y1="768.17"
					x2="752.3"
					y2="712.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="740 739.87 740.04 740.37 740.16 740.85 740.37 741.3 740.64 741.72 740.98 742.07 741.37 742.36 741.81 742.57 742.27 742.7 742.74 742.74 743.22 742.7 743.68 742.57 744.12 742.36 744.51 742.07 744.85 741.72 745.12 741.3 745.32 740.85 745.45 740.37 745.49 739.87 745.45 739.37 745.32 738.88 745.12 738.43 744.85 738.02 744.51 737.66 744.12 737.37 743.68 737.16 743.22 737.03 742.74 736.99 742.27 737.03 741.81 737.16 741.37 737.37 740.98 737.66 740.64 738.02 740.37 738.43 740.16 738.88 740.04 739.37 740 739.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="740.04"
					y1="739.37"
					x2="740"
					y2="739.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.16"
					y1="738.88"
					x2="740.04"
					y2="739.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.37"
					y1="738.43"
					x2="740.16"
					y2="738.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.64"
					y1="738.02"
					x2="740.37"
					y2="738.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.98"
					y1="737.66"
					x2="740.64"
					y2="738.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.37"
					y1="737.37"
					x2="740.98"
					y2="737.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.81"
					y1="737.16"
					x2="741.37"
					y2="737.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.27"
					y1="737.03"
					x2="741.81"
					y2="737.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.74"
					y1="736.99"
					x2="742.27"
					y2="737.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.22"
					y1="737.03"
					x2="742.74"
					y2="736.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.68"
					y1="737.16"
					x2="743.22"
					y2="737.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.12"
					y1="737.37"
					x2="743.68"
					y2="737.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.51"
					y1="737.66"
					x2="744.12"
					y2="737.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.85"
					y1="738.02"
					x2="744.51"
					y2="737.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.12"
					y1="738.43"
					x2="744.85"
					y2="738.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.32"
					y1="738.88"
					x2="745.12"
					y2="738.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.45"
					y1="739.37"
					x2="745.32"
					y2="738.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.49"
					y1="739.87"
					x2="745.45"
					y2="739.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.45"
					y1="740.37"
					x2="745.49"
					y2="739.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.32"
					y1="740.85"
					x2="745.45"
					y2="740.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.12"
					y1="741.3"
					x2="745.32"
					y2="740.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.85"
					y1="741.72"
					x2="745.12"
					y2="741.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.51"
					y1="742.07"
					x2="744.85"
					y2="741.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.12"
					y1="742.36"
					x2="744.51"
					y2="742.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.68"
					y1="742.57"
					x2="744.12"
					y2="742.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.22"
					y1="742.7"
					x2="743.68"
					y2="742.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.74"
					y1="742.74"
					x2="743.22"
					y2="742.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.27"
					y1="742.7"
					x2="742.74"
					y2="742.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.81"
					y1="742.57"
					x2="742.27"
					y2="742.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.37"
					y1="742.36"
					x2="741.81"
					y2="742.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.98"
					y1="742.07"
					x2="741.37"
					y2="742.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.64"
					y1="741.72"
					x2="740.98"
					y2="742.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.37"
					y1="741.3"
					x2="740.64"
					y2="741.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.16"
					y1="740.85"
					x2="740.37"
					y2="741.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.04"
					y1="740.37"
					x2="740.16"
					y2="740.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740"
					y1="739.87"
					x2="740.04"
					y2="740.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="755.51 737.38 755.92 737.42 756.32 737.54 756.7 737.72 757.03 737.97 757.32 738.27 757.56 738.62 757.74 739.02 757.84 739.44 757.88 739.87 757.84 740.3 757.74 740.72 757.56 741.11 757.32 741.46 757.03 741.77 756.7 742.02 756.32 742.2 755.92 742.31 755.51 742.35 751.54 741.95 751.22 741.9 750.92 741.79 750.63 741.63 745.62 740.97 745.44 740.93 745.27 740.86 745.12 740.76 744.99 740.64 744.87 740.49 744.78 740.33 744.72 740.15 744.69 739.96 744.69 739.77 744.72 739.59 744.78 739.41 744.87 739.24 744.99 739.1 745.12 738.97 745.27 738.88 745.44 738.8 745.62 738.76 750.63 738.11 750.92 737.95 751.22 737.84 751.54 737.78 755.51 737.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="755.51"
					y1="737.38"
					x2="751.54"
					y2="737.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.63"
					y1="738.11"
					x2="745.62"
					y2="738.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.62"
					y1="740.97"
					x2="750.63"
					y2="741.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.54"
					y1="741.95"
					x2="755.51"
					y2="742.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.15"
					y1="741.22"
					x2="751.74"
					y2="741.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.74"
					y1="738.52"
					x2="753.15"
					y2="738.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.15"
					y1="738.52"
					x2="753.15"
					y2="741.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m750.63,738.11c.27-.18.58-.29.9-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m745.62,740.97c-.53-.07-.93-.54-.93-1.1s.4-1.03.93-1.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m751.54,741.95c-.32-.03-.63-.14-.9-.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m755.51,737.38c1.31,0,2.37,1.11,2.37,2.48s-1.06,2.48-2.37,2.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m751.74,741.22c-.71,0-1.29-.6-1.29-1.35s.57-1.35,1.29-1.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m750.63,741.63c-.57-.38-.92-1.05-.92-1.76s.34-1.38.92-1.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="280.13 710.57 280.13 655.19 225.7 655.19 225.7 710.57 280.13 710.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="225.7"
					y1="710.57"
					x2="227.87"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.36"
					y1="710.57"
					x2="237.19"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.68"
					y1="710.57"
					x2="246.5"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250"
					y1="710.57"
					x2="255.82"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.32"
					y1="710.57"
					x2="265.14"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.64"
					y1="710.57"
					x2="274.46"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.96"
					y1="710.57"
					x2="280.13"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.7"
					y1="655.19"
					x2="225.7"
					y2="657.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.7"
					y1="661.33"
					x2="225.7"
					y2="667.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.7"
					y1="670.65"
					x2="225.7"
					y2="676.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.7"
					y1="679.97"
					x2="225.7"
					y2="685.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.7"
					y1="689.29"
					x2="225.7"
					y2="695.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.7"
					y1="698.61"
					x2="225.7"
					y2="704.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.7"
					y1="707.93"
					x2="225.7"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.13"
					y1="655.19"
					x2="277.96"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.46"
					y1="655.19"
					x2="268.64"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.14"
					y1="655.19"
					x2="259.32"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.82"
					y1="655.19"
					x2="250"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.5"
					y1="655.19"
					x2="240.68"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.19"
					y1="655.19"
					x2="231.36"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.87"
					y1="655.19"
					x2="225.7"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.13"
					y1="710.57"
					x2="280.13"
					y2="707.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.13"
					y1="704.43"
					x2="280.13"
					y2="698.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.13"
					y1="695.11"
					x2="280.13"
					y2="689.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.13"
					y1="685.79"
					x2="280.13"
					y2="679.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.13"
					y1="676.47"
					x2="280.13"
					y2="670.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.13"
					y1="667.15"
					x2="280.13"
					y2="661.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.13"
					y1="657.83"
					x2="280.13"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="225.91 713.44 225.91 715.11 279.92 715.11 279.92 713.44 271.45 713.44 271.45 714.81 234.38 714.81 234.38 713.44 225.91 713.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="234.38"
					y1="713.44"
					x2="225.91"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="234.38"
					y1="714.81"
					x2="234.38"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="271.45"
					y1="714.81"
					x2="234.38"
					y2="714.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="271.45"
					y1="713.44"
					x2="271.45"
					y2="714.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="279.92"
					y1="713.44"
					x2="271.45"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="279.92"
					y1="715.11"
					x2="279.92"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="225.91"
					y1="715.11"
					x2="279.92"
					y2="715.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="225.91"
					y1="713.44"
					x2="225.91"
					y2="715.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="223.79 713.44 282.04 713.44 282.04 710.57 223.79 710.57 223.79 713.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="223.79"
					y1="710.57"
					x2="223.79"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="282.04"
					y1="710.57"
					x2="223.79"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="282.04"
					y1="713.44"
					x2="282.04"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="223.79"
					y1="713.44"
					x2="282.04"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="279.92"
					y1="713.44"
					x2="279.92"
					y2="715.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.92"
					y1="715.11"
					x2="225.91"
					y2="715.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.91"
					y1="715.11"
					x2="225.91"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.04"
					y1="713.44"
					x2="223.79"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.38"
					y1="713.44"
					x2="234.38"
					y2="714.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.38"
					y1="714.81"
					x2="271.45"
					y2="714.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.45"
					y1="714.81"
					x2="271.45"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.04"
					y1="710.57"
					x2="282.04"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.79"
					y1="713.44"
					x2="223.79"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.79"
					y1="710.57"
					x2="282.04"
					y2="710.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="465.12 805.92 383.75 805.92 383.75 894.11 465.12 894.11 465.12 805.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="465.12"
					y1="894.11"
					x2="465.12"
					y2="805.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.75"
					y1="894.11"
					x2="465.12"
					y2="894.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.75"
					y1="805.92"
					x2="383.75"
					y2="894.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.12"
					y1="805.92"
					x2="383.75"
					y2="805.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.12"
					y1="811.98"
					x2="383.75"
					y2="811.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="288.64 706.46 349.1 706.46 350.05 706.2 350.76 705.5 351.01 704.55 351.01 664.08 350.76 663.12 350.05 662.42 349.1 662.17 288.64 662.17 287.69 662.42 286.99 663.12 286.73 664.08 286.73 704.55 286.99 705.5 287.69 706.2 288.64 706.46"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m288.64,706.46c-1.06,0-1.91-.86-1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.73"
					y1="664.08"
					x2="286.73"
					y2="704.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m286.73,664.08c0-1.05.86-1.91,1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.1"
					y1="662.17"
					x2="288.64"
					y2="662.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m349.1,662.17c1.06,0,1.91.86,1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.01"
					y1="704.55"
					x2="351.01"
					y2="664.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m351.01,704.55c0,1.06-.86,1.91-1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.64"
					y1="706.46"
					x2="349.1"
					y2="706.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.42"
					y1="701.68"
					x2="344.32"
					y2="701.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.23"
					y1="699.77"
					x2="346.23"
					y2="673.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.32"
					y1="671.72"
					x2="293.42"
					y2="671.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.51"
					y1="673.63"
					x2="291.51"
					y2="699.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.42"
					y1="701.68"
					x2="293.42"
					y2="701.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m346.23,699.77c0,1.06-.86,1.91-1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m344.32,671.72c1.06,0,1.91.86,1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m291.51,673.63c0-1.06.86-1.91,1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m293.42,701.68c-1.06,0-1.91-.86-1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m321.74,681.28c0-1.58-1.28-2.87-2.87-2.87s-2.87,1.28-2.87,2.87,1.28,2.87,2.87,2.87,2.87-1.29,2.87-2.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="318.01 683.94 318.27 684.55 318.87 684.8 319.48 684.55 319.73 683.94 319.73 665.03 319.48 664.42 318.87 664.17 318.26 664.42 318.01 665.03 318.01 683.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="318.01"
					y1="665.03"
					x2="318.01"
					y2="683.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m318.01,665.03c0-.47.38-.86.86-.86s.86.38.86.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.73"
					y1="683.94"
					x2="319.73"
					y2="665.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m319.73,683.94h0c0,.48-.39.86-.86.86s-.86-.38-.86-.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="316.96 669.91 318.01 669.91 318.01 665.03 318.26 664.42 318.87 664.17 319.48 664.42 319.73 665.03 319.73 669.91 320.78 669.91 320.78 663.7 316.96 663.7 316.96 669.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="316.96"
					y1="663.7"
					x2="316.96"
					y2="669.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.78"
					y1="663.7"
					x2="316.96"
					y2="663.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.78"
					y1="669.91"
					x2="320.78"
					y2="663.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.73"
					y1="669.91"
					x2="320.78"
					y2="669.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.73"
					y1="665.03"
					x2="319.73"
					y2="669.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m318.01,665.03c0-.47.38-.86.86-.86s.86.38.86.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.01"
					y1="669.91"
					x2="318.01"
					y2="665.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.96"
					y1="669.91"
					x2="318.01"
					y2="669.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="316.99 673.35 318.01 673.35 318.01 670 316.99 670 316.99 673.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="316.99"
					y1="670"
					x2="316.99"
					y2="673.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.01"
					y1="670"
					x2="316.99"
					y2="670"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.01"
					y1="673.35"
					x2="318.01"
					y2="670"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.99"
					y1="673.35"
					x2="318.01"
					y2="673.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="320.75 673.35 320.75 670 319.73 670 319.73 673.35 320.75 673.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="319.73"
					y1="673.35"
					x2="320.75"
					y2="673.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.73"
					y1="670"
					x2="319.73"
					y2="673.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.75"
					y1="670"
					x2="319.73"
					y2="670"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.75"
					y1="673.35"
					x2="320.75"
					y2="670"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="733.27 781.06 733.27 844.17 781.79 844.17 781.79 781.06 733.27 781.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="733.27"
					y1="781.06"
					x2="733.27"
					y2="844.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.79"
					y1="781.06"
					x2="781.79"
					y2="844.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.27"
					y1="844.17"
					x2="781.79"
					y2="844.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.27"
					y1="781.06"
					x2="781.79"
					y2="781.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.88"
					y1="781.06"
					x2="779.88"
					y2="844.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.79"
					y1="788.34"
					x2="744.79"
					y2="836.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.79"
					y1="836.88"
					x2="773.91"
					y2="836.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.91"
					y1="836.88"
					x2="773.91"
					y2="788.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.91"
					y1="788.34"
					x2="744.79"
					y2="788.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.88"
					y1="786.43"
					x2="742.88"
					y2="838.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.88"
					y1="838.8"
					x2="775.82"
					y2="838.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.82"
					y1="838.8"
					x2="775.82"
					y2="786.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.82"
					y1="786.43"
					x2="742.88"
					y2="786.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m770.2,812.62c0-1.58-1.28-2.87-2.86-2.87s-2.87,1.28-2.87,2.87,1.28,2.87,2.87,2.87,2.86-1.29,2.86-2.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="779.17 810.23 775.16 810.61 774.25 810.92 769.19 811.55 768.52 811.91 768.26 812.62 768.52 813.32 769.19 813.67 774.25 814.31 775.16 814.62 779.17 815 780.57 814.55 781.44 813.35 781.44 811.88 780.57 810.68 779.17 810.23"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m779.17,810.23c1.32,0,2.39,1.07,2.39,2.39s-1.07,2.39-2.39,2.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.16"
					y1="814.62"
					x2="779.17"
					y2="815"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m775.16,814.62c-.32-.03-.64-.14-.91-.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.19"
					y1="813.67"
					x2="774.25"
					y2="814.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m769.19,813.67c-.53-.07-.94-.52-.94-1.06s.4-1,.94-1.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.25"
					y1="810.92"
					x2="769.19"
					y2="811.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m774.25,810.92c.27-.18.58-.28.91-.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.17"
					y1="810.23"
					x2="775.16"
					y2="810.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.79"
					y1="813.91"
					x2="775.37"
					y2="813.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.37"
					y1="811.32"
					x2="776.79"
					y2="811.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.79"
					y1="811.32"
					x2="776.79"
					y2="813.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m775.37,813.91c-.72,0-1.3-.58-1.3-1.3s.58-1.3,1.3-1.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m774.25,814.31c-.58-.37-.93-1.01-.93-1.69s.35-1.32.93-1.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.73"
					y1="647.36"
					x2="628.18"
					y2="647.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.18"
					y1="647.36"
					x2="628.18"
					y2="605.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.73"
					y1="656.24"
					x2="643.73"
					y2="596.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.7"
					y1="596.27"
					x2="683.7"
					y2="656.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.7"
					y1="656.24"
					x2="623.74"
					y2="656.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.74"
					y1="596.27"
					x2="683.7"
					y2="596.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.85"
					y1="656.24"
					x2="624.85"
					y2="596.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.73"
					y1="605.16"
					x2="628.18"
					y2="605.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.74"
					y1="656.24"
					x2="623.74"
					y2="596.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.75"
					y1="814.98"
					x2="213.13"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.46"
					y1="805.92"
					x2="386.46"
					y2="800.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.46"
					y1="800.56"
					x2="389.17"
					y2="800.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.17"
					y1="800.56"
					x2="389.17"
					y2="805.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.12"
					y1="814.98"
					x2="463.32"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.97"
					y1="814.98"
					x2="454.14"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.65"
					y1="814.98"
					x2="444.82"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.33"
					y1="814.98"
					x2="435.5"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.01"
					y1="814.98"
					x2="426.18"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.69"
					y1="814.98"
					x2="416.86"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.37"
					y1="814.98"
					x2="407.54"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.05"
					y1="814.98"
					x2="398.22"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.73"
					y1="814.98"
					x2="388.9"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.55"
					y1="814.98"
					x2="383.75"
					y2="814.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.79"
					y1="655.19"
					x2="227.85"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.34"
					y1="655.19"
					x2="237.17"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.66"
					y1="655.19"
					x2="246.49"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.98"
					y1="655.19"
					x2="255.81"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.3"
					y1="655.19"
					x2="265.12"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.62"
					y1="655.19"
					x2="274.44"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.94"
					y1="655.19"
					x2="283.76"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.26"
					y1="655.19"
					x2="293.08"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="296.58"
					y1="655.19"
					x2="302.4"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.9"
					y1="655.19"
					x2="311.72"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.22"
					y1="655.19"
					x2="321.04"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.54"
					y1="655.19"
					x2="330.36"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.86"
					y1="655.19"
					x2="339.68"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.18"
					y1="655.19"
					x2="349"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.5"
					y1="655.19"
					x2="358.32"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.82"
					y1="655.19"
					x2="367.64"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.14"
					y1="655.19"
					x2="376.96"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.46"
					y1="655.19"
					x2="386.28"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.78"
					y1="655.19"
					x2="395.6"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.1"
					y1="655.19"
					x2="404.92"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.42"
					y1="655.19"
					x2="414.24"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.74"
					y1="655.19"
					x2="423.56"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.05"
					y1="655.19"
					x2="432.88"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.37"
					y1="655.19"
					x2="442.2"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.69"
					y1="655.19"
					x2="449.75"
					y2="655.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.06"
					y1="53.8"
					x2="458.85"
					y2="63.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.87"
					y1="82.76"
					x2="268.08"
					y2="73.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.41"
					y1="89.39"
					x2="750.68"
					y2="97.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.66"
					y1="78.13"
					x2="590.39"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.04"
					y1="647.36"
					x2="677.04"
					y2="605.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.04"
					y1="605.16"
					x2="648.17"
					y2="605.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.17"
					y1="605.16"
					x2="648.17"
					y2="647.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.17"
					y1="647.36"
					x2="677.04"
					y2="647.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="359.45 810.13 286.64 810.13 286.64 873.23 359.45 873.23 359.45 810.13"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="359.45"
					y1="810.13"
					x2="286.64"
					y2="810.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.45"
					y1="873.23"
					x2="286.64"
					y2="873.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.45"
					y1="871.32"
					x2="286.64"
					y2="871.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.45"
					y1="810.13"
					x2="359.45"
					y2="873.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.64"
					y1="810.13"
					x2="286.64"
					y2="873.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.68"
					y1="812.99"
					x2="291.42"
					y2="812.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.42"
					y1="812.99"
					x2="289.51"
					y2="814.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.51"
					y1="814.9"
					x2="289.51"
					y2="868.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.51"
					y1="868.45"
					x2="291.42"
					y2="870.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.42"
					y1="870.36"
					x2="354.68"
					y2="870.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.68"
					y1="870.36"
					x2="356.59"
					y2="868.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.59"
					y1="868.45"
					x2="356.59"
					y2="814.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.59"
					y1="814.9"
					x2="354.68"
					y2="812.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m350.81,825.9c0-5.28-4.28-9.56-9.55-9.56s-9.56,4.28-9.56,9.56,4.28,9.56,9.56,9.56,9.55-4.28,9.55-9.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m348.42,857.45c0-3.96-3.21-7.16-7.17-7.16s-7.17,3.21-7.17,7.16,3.21,7.17,7.17,7.17,7.17-3.21,7.17-7.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m312.01,825.9c0-3.96-3.21-7.17-7.17-7.17s-7.17,3.21-7.17,7.17,3.21,7.17,7.17,7.17,7.17-3.21,7.17-7.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m314.4,857.45c0-5.28-4.28-9.55-9.55-9.55s-9.56,4.28-9.56,9.55,4.28,9.56,9.56,9.56,9.55-4.28,9.55-9.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.75"
					y1="844.11"
					x2="379.4"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.91"
					y1="844.11"
					x2="370.08"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.59"
					y1="844.11"
					x2="360.76"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.27"
					y1="844.11"
					x2="351.44"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.95"
					y1="844.11"
					x2="342.12"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.63"
					y1="844.11"
					x2="332.8"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.31"
					y1="844.11"
					x2="323.49"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.99"
					y1="844.11"
					x2="314.17"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.67"
					y1="844.11"
					x2="304.84"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.35"
					y1="844.11"
					x2="295.52"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.03"
					y1="844.11"
					x2="286.21"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.71"
					y1="844.11"
					x2="276.89"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.39"
					y1="844.11"
					x2="267.57"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.07"
					y1="844.11"
					x2="258.25"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.75"
					y1="844.11"
					x2="248.93"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.43"
					y1="844.11"
					x2="239.61"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.11"
					y1="844.11"
					x2="230.29"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.79"
					y1="844.11"
					x2="220.97"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.47"
					y1="844.11"
					x2="213.13"
					y2="844.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="508.2 916.26 507.26 935.65 213.13 921.53 193.71 920.59 193.71 50 213.13 50.98 269.06 53.8 268.08 73.19 223.95 70.97 223.95 111.21 213.13 111.21 213.13 373.31 247.61 373.31 247.61 461.67 213.13 461.67 213.13 626.64 223.78 626.64 223.78 713.43 213.13 713.43 213.13 873.22 383.75 873.22 383.75 894.11 465.12 894.11 465.12 914.19 508.2 916.26"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.25"
				/>
				<polygon
					points="806.29 80.89 806.29 950 786.87 949.07 599.38 940.07 600.32 920.68 605.39 920.92 605.39 910.65 617.53 910.65 617.53 921.5 786.87 929.63 781.8 929.38 781.8 776.96 761.3 776.96 761.3 702.78 617.53 702.78 617.53 823.29 605.39 823.29 605.39 660.68 617.53 660.68 617.53 664.42 695.05 664.42 695.05 580.87 617.53 580.87 617.53 592.73 605.39 592.73 605.39 573.93 597.35 573.93 597.35 561.78 633.07 561.78 633.07 504.16 516.56 504.16 516.56 561.78 529.38 561.78 529.38 573.93 504.42 573.93 504.42 480.38 516.56 480.38 516.56 492.03 633.07 492.03 633.07 410.75 656.9 410.75 656.9 422.89 645.2 422.89 645.2 568.73 786.87 568.73 786.87 422.89 744.28 422.89 744.28 410.75 786.87 410.75 786.87 140.26 777.9 140.26 777.9 98.9 750.67 97.52 751.66 78.13 786.87 79.91 806.29 80.89"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.25"
				/>
				<polygon
					points="590.39 70.01 589.41 89.4 573.09 88.57 573.09 168.98 516.56 168.98 516.56 393.02 504.42 393.02 504.42 85.11 457.87 82.77 458.85 63.37 590.39 70.01"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.25"
				/>
			</g>
			<g id="text">
				<path d="m241.02,689.39v-11.25h3.88c.88,0,1.54.05,2,.16.64.15,1.19.42,1.65.81.59.5,1.04,1.14,1.33,1.93.3.78.45,1.67.45,2.67,0,.85-.1,1.61-.3,2.27-.2.66-.46,1.21-.77,1.64-.31.43-.66.77-1.03,1.02-.37.25-.82.43-1.34.56-.52.13-1.12.19-1.8.19h-4.06Zm1.49-1.33h2.4c.74,0,1.32-.07,1.74-.21.42-.14.76-.33,1.01-.58.35-.35.63-.83.82-1.42.2-.6.3-1.32.3-2.17,0-1.18-.19-2.08-.58-2.71-.38-.63-.85-1.06-1.4-1.27-.4-.15-1.04-.23-1.93-.23h-2.36v8.6Zm11.83,1.33l-2.99-11.25h1.53l1.71,7.38c.18.77.34,1.54.48,2.3.29-1.2.46-1.9.51-2.08l2.14-7.6h1.8l1.61,5.7c.4,1.41.7,2.74.88,3.98.14-.71.33-1.53.56-2.45l1.77-7.23h1.5l-3.09,11.25h-1.44l-2.37-8.57c-.2-.72-.32-1.16-.35-1.32-.12.52-.23.96-.33,1.32l-2.39,8.57h-1.52Z" />
				<path d="m420.88,856.76h-1.58l-1.9-3.18c-.17-.3-.34-.55-.51-.75-.16-.21-.33-.38-.51-.51-.17-.13-.35-.23-.55-.28-.19-.06-.42-.09-.66-.09h-1.09v4.82h-1.33v-11.34h3.38c.5,0,.95.06,1.37.19.42.12.79.31,1.09.56.31.25.55.57.73.95.17.37.26.81.26,1.32,0,.4-.06.76-.18,1.09-.12.33-.28.62-.51.88-.22.26-.48.48-.79.66-.31.18-.65.32-1.04.42v.03c.19.08.35.18.49.29.14.11.28.23.4.38.13.15.25.32.37.51.13.18.27.4.42.65l2.13,3.41Zm-6.8-10.13v4.11h1.8c.33,0,.64-.05.92-.15.28-.1.53-.24.74-.43.21-.19.37-.42.48-.69.12-.27.17-.58.17-.92,0-.61-.2-1.08-.59-1.41-.39-.34-.96-.51-1.7-.51h-1.82Zm14.54,6.41h-5.71c.02.9.26,1.6.73,2.09.46.49,1.1.74,1.91.74.91,0,1.75-.3,2.51-.9v1.22c-.71.52-1.65.77-2.82.77s-2.04-.37-2.7-1.1c-.65-.74-.98-1.77-.98-3.11,0-1.26.36-2.28,1.07-3.07.72-.8,1.6-1.19,2.66-1.19s1.88.34,2.46,1.03c.58.68.87,1.64.87,2.85v.68Zm-1.33-1.1c0-.75-.19-1.33-.55-1.75-.35-.42-.85-.62-1.48-.62s-1.13.22-1.56.66c-.43.44-.69,1.01-.79,1.72h4.37Zm7.14-6.02c-.25-.14-.54-.21-.86-.21-.91,0-1.36.57-1.36,1.72v1.25h1.9v1.11h-1.9v6.99h-1.29v-6.99h-1.38v-1.11h1.38v-1.31c0-.85.25-1.52.74-2.01.49-.5,1.1-.74,1.83-.74.4,0,.71.05.94.14v1.17Z" />
				<path d="m435.8,856.93c-.24,0-.45-.09-.62-.26-.17-.17-.25-.38-.25-.62s.08-.45.25-.62c.17-.18.38-.27.62-.27s.46.09.63.27c.17.17.26.38.26.62s-.09.45-.26.62c-.17.17-.38.26-.63.26Z" />
				<path d="m652.75,821.03v-17.59h5.01c1.52,0,2.73.37,3.62,1.12.89.74,1.34,1.71,1.34,2.91,0,1-.27,1.86-.81,2.6-.54.74-1.28,1.26-2.23,1.57v.05c1.19.14,2.13.59,2.85,1.35.71.75,1.07,1.73,1.07,2.94,0,1.51-.54,2.72-1.62,3.66-1.08.93-2.44,1.4-4.09,1.4h-5.13Zm2.06-15.73v5.68h2.11c1.13,0,2.02-.27,2.66-.81.65-.55.97-1.32.97-2.31,0-1.71-1.12-2.56-3.37-2.56h-2.37Zm0,7.53v6.33h2.8c1.21,0,2.15-.29,2.81-.86.67-.57,1.01-1.36,1.01-2.36,0-2.08-1.42-3.12-4.25-3.12h-2.37Zm21.06,8.2h-2.01v-1.96h-.05c-.88,1.51-2.16,2.26-3.86,2.26-1.25,0-2.23-.33-2.94-.99-.7-.66-1.06-1.54-1.06-2.64,0-2.35,1.38-3.71,4.15-4.1l3.77-.53c0-2.13-.86-3.2-2.59-3.2-1.51,0-2.88.52-4.1,1.55v-2.06c1.24-.79,2.66-1.18,4.27-1.18,2.95,0,4.43,1.56,4.43,4.69v8.17Zm-2.01-6.36l-3.03.42c-.93.13-1.64.36-2.11.7-.47.33-.71.91-.71,1.75,0,.61.22,1.12.65,1.51.44.38,1.03.58,1.75.58,1,0,1.82-.35,2.47-1.04.65-.7.98-1.59.98-2.66v-1.25Zm11.63,6.23c-.47.26-1.1.39-1.88.39-2.2,0-3.3-1.23-3.3-3.68v-7.44h-2.16v-1.72h2.16v-3.07l2.01-.65v3.72h3.17v1.72h-3.17v7.08c0,.84.14,1.44.43,1.8.29.36.76.54,1.42.54.51,0,.94-.14,1.31-.42v1.72Zm13.12.12h-2.01v-7.24c0-2.62-.97-3.93-2.92-3.93-.98,0-1.81.38-2.48,1.14-.67.75-1.01,1.72-1.01,2.91v7.12h-2.01v-18.6h2.01v8.12h.05c.97-1.59,2.34-2.38,4.12-2.38,2.83,0,4.25,1.71,4.25,5.12v7.74Z" />
				<path d="m683.86,484.61l-3.61,12.8h-1.76l-2.63-9.35c-.11-.4-.18-.83-.21-1.3h-.04c-.04.44-.11.87-.23,1.28l-2.65,9.37h-1.74l-3.75-12.8h1.65l2.72,9.82c.11.41.18.84.21,1.28h.04c.03-.32.12-.74.28-1.28l2.83-9.82h1.44l2.71,9.89c.1.34.17.74.21,1.2h.04c.02-.31.1-.72.24-1.23l2.61-9.85h1.62Zm8.05,12.8h-1.46v-1.43h-.04c-.64,1.09-1.57,1.64-2.81,1.64-.91,0-1.62-.24-2.14-.72-.51-.48-.77-1.12-.77-1.92,0-1.71,1.01-2.7,3.02-2.98l2.74-.38c0-1.55-.63-2.33-1.88-2.33-1.1,0-2.09.37-2.98,1.12v-1.5c.9-.57,1.93-.86,3.11-.86,2.15,0,3.22,1.14,3.22,3.41v5.94Zm-1.46-4.62l-2.2.3c-.68.1-1.19.26-1.53.51-.34.24-.52.66-.52,1.28,0,.45.16.81.47,1.1.32.28.75.42,1.28.42.73,0,1.32-.25,1.79-.76.48-.51.71-1.16.71-1.94v-.91Zm5.5,4.62h-1.46v-13.53h1.46v13.53Zm10.35,0h-2.05l-4.03-4.39h-.04v4.39h-1.46v-13.53h1.46v8.58h.04l3.84-4.19h1.92l-4.24,4.41,4.57,4.73Z" />
				<rect x="707.41" y="491.74" width="4.87" height="1.15" />
				<path d="m716.61,497.4h-1.5v-12.8h1.5v12.8Zm10.76,0h-1.46v-5.21c0-1.94-.71-2.91-2.12-2.91-.73,0-1.34.28-1.82.83-.48.55-.71,1.24-.71,2.08v5.21h-1.46v-9.14h1.46v1.52h.04c.69-1.15,1.69-1.73,3-1.73,1,0,1.76.32,2.29.97.53.64.79,1.57.79,2.79v5.59Z" />
				<path d="m683.25,521.23c-.95.5-2.12.75-3.53.75-1.82,0-3.28-.59-4.37-1.76-1.09-1.17-1.64-2.71-1.64-4.61,0-2.05.62-3.7,1.85-4.96,1.23-1.26,2.79-1.89,4.68-1.89,1.21,0,2.22.18,3.02.53v1.6c-.92-.51-1.93-.77-3.03-.77-1.47,0-2.66.49-3.58,1.47-.91.98-1.37,2.29-1.37,3.94s.43,2.8,1.28,3.73c.86.92,1.98,1.38,3.36,1.38,1.28,0,2.4-.29,3.34-.86v1.45Zm3.87.54h-1.46v-13.53h1.46v13.53Zm6.78.21c-1.35,0-2.43-.43-3.24-1.28-.8-.86-1.2-1.99-1.2-3.4,0-1.53.42-2.73,1.26-3.6.84-.86,1.97-1.29,3.4-1.29s2.42.42,3.19,1.26c.77.84,1.15,2,1.15,3.49s-.41,2.63-1.24,3.51c-.82.87-1.92,1.31-3.31,1.31Zm.11-8.33c-.94,0-1.68.32-2.23.96-.55.64-.82,1.52-.82,2.64s.28,1.94.83,2.56c.55.62,1.29.94,2.22.94s1.67-.31,2.18-.92c.51-.61.77-1.48.77-2.61s-.26-2.02-.77-2.64c-.51-.62-1.23-.93-2.18-.93Zm6.23,7.79v-1.57c.8.59,1.67.88,2.63.88,1.28,0,1.93-.43,1.93-1.28,0-.24-.06-.45-.17-.62-.11-.17-.26-.32-.45-.46-.18-.13-.4-.25-.66-.35-.25-.11-.52-.22-.81-.33-.4-.16-.76-.32-1.07-.48-.3-.17-.56-.35-.77-.55-.2-.21-.36-.44-.46-.7-.1-.26-.15-.57-.15-.92,0-.43.1-.81.29-1.13.2-.33.46-.61.79-.83.33-.23.7-.4,1.12-.51.42-.11.86-.17,1.3-.17.79,0,1.5.14,2.12.41v1.48c-.67-.44-1.45-.66-2.32-.66-.27,0-.52.03-.74.1-.22.06-.41.15-.57.26-.15.11-.28.25-.37.41-.08.15-.12.33-.12.52,0,.24.04.44.12.6.09.16.22.3.38.43.17.12.37.24.61.34.24.1.51.21.81.33.4.15.77.32,1.09.48.32.16.59.35.82.55.23.2.4.44.52.7.12.27.19.59.19.95,0,.45-.1.84-.3,1.18-.2.33-.46.61-.79.83-.33.22-.72.38-1.15.49-.43.11-.89.16-1.37.16-.94,0-1.75-.18-2.45-.54Zm15.65-3.87h-6.45c.02,1.02.3,1.8.82,2.36.52.55,1.24.83,2.16.83,1.03,0,1.97-.34,2.84-1.02v1.37c-.8.58-1.86.87-3.19.87s-2.31-.41-3.04-1.24c-.74-.83-1.11-2-1.11-3.51,0-1.42.4-2.58,1.2-3.47.81-.9,1.81-1.35,3.01-1.35s2.12.39,2.78,1.16c.65.77.98,1.85.98,3.22v.77Zm-1.5-1.24c0-.84-.21-1.5-.62-1.97-.4-.47-.95-.7-1.67-.7s-1.28.25-1.76.74c-.48.49-.78,1.14-.89,1.94h4.93Zm7.95,5.35c-.34.19-.8.29-1.37.29-1.6,0-2.4-.89-2.4-2.68v-5.41h-1.57v-1.25h1.57v-2.23l1.46-.47v2.7h2.3v1.25h-2.3v5.15c0,.61.1,1.05.31,1.31.21.26.55.39,1.04.39.37,0,.69-.1.95-.3v1.25Z" />
				<path d="m518.66,839.43h-9.32v-17.59h8.93v1.86h-6.87v5.85h6.36v1.85h-6.36v6.16h7.26v1.86Zm13.57,0h-2.01v-7.17c0-2.67-.97-4-2.92-4-1.01,0-1.84.38-2.5,1.14-.65.75-.98,1.71-.98,2.86v7.17h-2.01v-12.56h2.01v2.09h.05c.95-1.59,2.32-2.38,4.12-2.38,1.37,0,2.43.45,3.15,1.34.73.88,1.09,2.16,1.09,3.84v7.68Zm9.64-.12c-.47.26-1.1.39-1.88.39-2.2,0-3.3-1.23-3.3-3.68v-7.44h-2.16v-1.72h2.16v-3.07l2.01-.65v3.72h3.17v1.72h-3.17v7.08c0,.84.14,1.44.43,1.8.29.36.76.54,1.42.54.51,0,.94-.14,1.31-.42v1.72Zm9.26-10.4c-.35-.27-.86-.4-1.52-.4-.86,0-1.58.4-2.16,1.21-.57.81-.86,1.91-.86,3.31v6.4h-2.01v-12.56h2.01v2.59h.05c.29-.88.72-1.57,1.31-2.06.59-.5,1.25-.75,1.98-.75.52,0,.92.06,1.2.17v2.09Zm12.21-2.04l-5.78,14.58c-1.03,2.6-2.48,3.9-4.34,3.9-.52,0-.96-.05-1.31-.16v-1.8c.43.15.83.22,1.19.22,1.01,0,1.77-.61,2.28-1.82l1.01-2.38-4.91-12.54h2.23l3.4,9.67c.04.12.13.44.26.96h.07c.04-.2.12-.51.25-.93l3.57-9.69h2.09Z" />
				<path d="m598.53,253.11v-17.59h5.01c1.52,0,2.73.37,3.62,1.12s1.34,1.71,1.34,2.91c0,1-.27,1.86-.81,2.6-.54.74-1.28,1.26-2.23,1.57v.05c1.19.14,2.13.59,2.85,1.35.71.75,1.07,1.73,1.07,2.94,0,1.51-.54,2.72-1.62,3.66-1.08.93-2.44,1.4-4.09,1.4h-5.13Zm2.06-15.73v5.68h2.11c1.13,0,2.02-.27,2.66-.81.65-.55.97-1.32.97-2.31,0-1.71-1.12-2.56-3.37-2.56h-2.37Zm0,7.53v6.33h2.8c1.21,0,2.15-.29,2.81-.86.67-.57,1.01-1.36,1.01-2.36,0-2.08-1.42-3.12-4.25-3.12h-2.37Zm22.14,2.42h-8.87c.03,1.4.41,2.48,1.13,3.24.72.76,1.71,1.14,2.97,1.14,1.42,0,2.72-.47,3.9-1.4v1.89c-1.1.8-2.56,1.2-4.38,1.2s-3.17-.57-4.18-1.71c-1.01-1.15-1.52-2.75-1.52-4.82,0-1.95.55-3.55,1.66-4.77,1.11-1.24,2.49-1.85,4.13-1.85s2.92.53,3.82,1.6c.9,1.06,1.35,2.54,1.35,4.43v1.06Zm-2.06-1.71c0-1.16-.29-2.07-.85-2.71-.55-.65-1.31-.97-2.29-.97s-1.75.34-2.42,1.02c-.66.68-1.07,1.57-1.23,2.66h6.78Zm15.81,7.48h-2.01v-2.13h-.05c-.93,1.62-2.37,2.43-4.32,2.43-1.58,0-2.84-.56-3.79-1.68-.94-1.13-1.41-2.66-1.41-4.6,0-2.08.52-3.74,1.57-4.99,1.05-1.25,2.44-1.88,4.18-1.88s2.98.68,3.77,2.04h.05v-7.78h2.01v18.6Zm-2.01-5.68v-1.85c0-1.01-.34-1.87-1.01-2.58-.67-.7-1.52-1.06-2.55-1.06-1.23,0-2.19.45-2.9,1.35-.7.9-1.06,2.14-1.06,3.73,0,1.45.34,2.59,1.01,3.44.68.83,1.59,1.25,2.72,1.25s2.03-.4,2.72-1.21c.7-.81,1.06-1.83,1.06-3.07Zm12.62-4.85c-.35-.27-.86-.4-1.52-.4-.86,0-1.58.4-2.16,1.21-.57.81-.86,1.91-.86,3.31v6.4h-2.01v-12.56h2.01v2.59h.05c.29-.88.72-1.57,1.31-2.06.59-.5,1.25-.75,1.98-.75.52,0,.92.06,1.2.17v2.09Zm7.42,10.82c-1.86,0-3.34-.58-4.45-1.75-1.1-1.18-1.66-2.74-1.66-4.67,0-2.11.58-3.76,1.73-4.94,1.15-1.19,2.71-1.78,4.67-1.78s3.33.58,4.38,1.73c1.06,1.15,1.58,2.75,1.58,4.8s-.57,3.61-1.71,4.82c-1.13,1.2-2.65,1.8-4.55,1.8Zm.15-11.46c-1.29,0-2.31.44-3.07,1.33-.75.88-1.13,2.09-1.13,3.63s.38,2.66,1.14,3.52c.76.86,1.78,1.29,3.06,1.29s2.3-.42,2.99-1.26c.7-.84,1.06-2.04,1.06-3.59s-.35-2.78-1.06-3.63c-.7-.85-1.69-1.28-2.99-1.28Zm14.56,11.46c-1.86,0-3.34-.58-4.45-1.75-1.1-1.18-1.66-2.74-1.66-4.67,0-2.11.58-3.76,1.73-4.94,1.15-1.19,2.71-1.78,4.67-1.78s3.33.58,4.38,1.73c1.06,1.15,1.58,2.75,1.58,4.8s-.57,3.61-1.71,4.82c-1.13,1.2-2.65,1.8-4.55,1.8Zm.15-11.46c-1.29,0-2.31.44-3.07,1.33-.75.88-1.13,2.09-1.13,3.63s.38,2.66,1.14,3.52,1.78,1.29,3.06,1.29,2.3-.42,2.99-1.26c.7-.84,1.06-2.04,1.06-3.59s-.35-2.78-1.06-3.63c-.7-.85-1.69-1.28-2.99-1.28Zm27.14,11.17h-2.01v-7.21c0-1.39-.22-2.4-.65-3.02-.43-.62-1.15-.93-2.16-.93-.86,0-1.59.39-2.2,1.18-.6.79-.9,1.73-.9,2.82v7.17h-2.01v-7.46c0-2.47-.95-3.71-2.86-3.71-.88,0-1.61.37-2.18,1.12-.57.74-.86,1.7-.86,2.88v7.17h-2.01v-12.56h2.01v1.99h.05c.89-1.52,2.19-2.28,3.9-2.28.86,0,1.61.24,2.25.72.64.47,1.08,1.1,1.31,1.88.93-1.73,2.32-2.6,4.17-2.6,2.76,0,4.15,1.71,4.15,5.12v7.74Z" />
				<path d="m610.99,272.02c0,1.17-.12,2.22-.35,3.13-.23.91-.57,1.68-1.02,2.32-.45.63-.99,1.11-1.63,1.45-.64.33-1.37.49-2.2.49s-1.59-.15-2.23-.45v-1.4c.71.4,1.46.6,2.27.6.58,0,1.09-.12,1.54-.36.46-.24.84-.58,1.16-1.04.32-.46.56-1.02.72-1.69.17-.67.25-1.43.25-2.29h-.04c-.55,1.1-1.5,1.65-2.86,1.65-.55,0-1.05-.1-1.51-.29-.46-.2-.85-.47-1.19-.82-.33-.36-.59-.78-.78-1.27s-.28-1.03-.28-1.62c0-.63.1-1.21.3-1.73.21-.52.49-.97.86-1.35.37-.38.8-.68,1.3-.88.51-.21,1.06-.31,1.65-.31.64,0,1.21.13,1.7.39.5.26.92.63,1.26,1.13.34.49.6,1.1.78,1.83.18.73.27,1.56.27,2.49Zm-1.58-1.31c0-.49-.07-.94-.2-1.35-.12-.4-.3-.75-.53-1.04-.23-.29-.5-.51-.81-.67-.31-.16-.65-.24-1.02-.24s-.68.07-.98.21c-.3.14-.57.33-.79.59-.22.25-.4.55-.53.9-.12.35-.19.72-.19,1.13,0,.45.06.86.18,1.21.12.36.3.66.53.91.23.24.5.43.81.56.32.13.68.2,1.06.2.34,0,.66-.06.95-.19.3-.13.57-.3.79-.52.23-.22.4-.48.53-.77.13-.3.2-.62.2-.95Z" />
				<rect x="613.35" y="266.39" width="1.29" height="3.99" />
				<path d="m623.63,266.39v8.45h1.64v1.34h-1.64v3.01h-1.45v-3.01h-6.01v-1.27c.56-.63,1.12-1.3,1.7-2.02.57-.72,1.12-1.45,1.63-2.19.52-.74,1.01-1.47,1.45-2.2.45-.74.82-1.44,1.12-2.11h1.56Zm-5.81,8.45h4.36v-6.26c-.45.78-.87,1.48-1.27,2.09-.4.61-.78,1.17-1.14,1.67-.36.5-.7.95-1.03,1.36-.33.4-.64.79-.93,1.15Z" />
				<path d="m628.66,266.39v3.99h-1.29v-3.99h1.29Zm2.96,0v3.99h-1.29v-3.99h1.29Z" />
				<path d="m646.25,270.05l-3.07,4.62,3.02,4.52h-1.7l-1.79-2.96c-.11-.18-.25-.42-.4-.7h-.04c-.03.05-.17.29-.42.7l-1.83,2.96h-1.69l3.11-4.48-2.98-4.66h1.7l1.77,3.12c.13.23.26.47.38.71h.04l2.28-3.84h1.62Z" />
				<path d="m657.95,279.19h-1.46v-11.06c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.12-.59.22-.87.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.08Zm9.87,0h-1.46v-11.06c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.12-.59.22-.87.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.08Z" />
				<rect x="672.68" y="266.39" width="1.29" height="3.99" />
				<path d="m681.83,279.19h-1.46v-11.06c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.12-.59.22-.87.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.08Z" />
				<path d="m687.99,266.39v3.99h-1.29v-3.99h1.29Zm2.96,0v3.99h-1.29v-3.99h1.29Z" />
				<path d="m304.87,774.68h-2.87l-6.8-8.05c-.25-.3-.41-.51-.47-.61h-.05v8.66h-2.06v-17.59h2.06v8.27h.05c.11-.18.27-.38.47-.6l6.58-7.67h2.56l-7.55,8.44,8.07,9.15Zm3.07-15.75c-.36,0-.67-.12-.92-.37-.25-.25-.38-.56-.38-.93s.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.56.38-.93.38Zm.98,15.75h-2.01v-12.56h2.01v12.56Zm9.88-.12c-.47.26-1.1.39-1.88.39-2.2,0-3.3-1.23-3.3-3.68v-7.44h-2.16v-1.72h2.16v-3.07l2.01-.65v3.72h3.17v1.72h-3.17v7.08c0,.84.14,1.44.43,1.8.29.36.76.54,1.42.54.51,0,.94-.14,1.31-.42v1.72Zm11.24-.45c-.97.58-2.11.87-3.44.87-1.79,0-3.24-.58-4.34-1.74-1.1-1.17-1.64-2.68-1.64-4.54,0-2.07.59-3.73,1.78-4.98,1.19-1.26,2.77-1.89,4.75-1.89,1.1,0,2.08.2,2.92.61v2.06c-.93-.65-1.93-.98-2.99-.98-1.28,0-2.34.46-3.17,1.39-.82.92-1.23,2.12-1.23,3.62s.38,2.63,1.15,3.48c.78.85,1.82,1.28,3.12,1.28,1.1,0,2.13-.36,3.09-1.09v1.91Zm13.46.58h-2.01v-7.24c0-2.62-.97-3.93-2.92-3.93-.98,0-1.81.38-2.48,1.14-.67.75-1.01,1.72-1.01,2.91v7.12h-2.01v-18.6h2.01v8.12h.05c.97-1.59,2.34-2.38,4.12-2.38,2.83,0,4.25,1.71,4.25,5.12v7.74Zm13.87-5.78h-8.87c.03,1.4.41,2.48,1.13,3.24s1.71,1.14,2.97,1.14c1.42,0,2.72-.47,3.9-1.4v1.89c-1.1.8-2.56,1.2-4.38,1.2s-3.17-.57-4.18-1.71c-1.01-1.15-1.52-2.75-1.52-4.82,0-1.95.55-3.55,1.66-4.77,1.11-1.24,2.49-1.85,4.13-1.85s2.92.53,3.82,1.6c.9,1.06,1.35,2.54,1.35,4.43v1.06Zm-2.06-1.71c0-1.16-.29-2.07-.85-2.71-.55-.65-1.31-.97-2.29-.97s-1.75.34-2.42,1.02c-.66.68-1.07,1.57-1.23,2.66h6.78Zm15.52,7.48h-2.01v-7.17c0-2.67-.97-4-2.92-4-1.01,0-1.84.38-2.5,1.14-.65.75-.98,1.71-.98,2.86v7.17h-2.01v-12.56h2.01v2.09h.05c.95-1.59,2.32-2.38,4.12-2.38,1.37,0,2.43.45,3.15,1.34.73.88,1.09,2.16,1.09,3.84v7.68Z" />
				<path d="m260.24,354.16h-9.13v-17.59h2.06v15.73h7.07v1.86Zm3.46-15.75c-.36,0-.67-.12-.92-.37-.25-.25-.38-.56-.38-.93s.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.56.38-.93.38Zm.98,15.75h-2.01v-12.56h2.01v12.56Zm13.94-12.56l-5.01,12.56h-1.98l-4.76-12.56h2.21l3.19,9.13c.24.67.38,1.26.44,1.75h.05c.08-.63.21-1.2.39-1.71l3.34-9.18h2.12Zm3.18-3.19c-.36,0-.67-.12-.92-.37-.25-.25-.38-.56-.38-.93s.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.56.38-.93.38Zm.98,15.75h-2.01v-12.56h2.01v12.56Zm14.49,0h-2.01v-7.17c0-2.67-.97-4-2.92-4-1.01,0-1.84.38-2.5,1.14-.65.75-.98,1.71-.98,2.86v7.17h-2.01v-12.56h2.01v2.09h.05c.95-1.59,2.32-2.38,4.12-2.38,1.37,0,2.43.45,3.15,1.34.73.88,1.09,2.16,1.09,3.84v7.68Zm14.51-1.01c0,4.61-2.21,6.92-6.63,6.92-1.55,0-2.91-.29-4.07-.88v-2.01c1.42.79,2.76,1.18,4.05,1.18,3.09,0,4.64-1.64,4.64-4.93v-1.37h-.05c-.96,1.6-2.4,2.4-4.32,2.4-1.56,0-2.82-.56-3.78-1.67-.95-1.12-1.42-2.62-1.42-4.5,0-2.13.51-3.83,1.53-5.09,1.03-1.26,2.44-1.89,4.22-1.89s2.95.68,3.77,2.04h.05v-1.74h2.01v11.56Zm-2.01-4.67v-1.85c0-1-.34-1.85-1.02-2.56-.67-.71-1.51-1.07-2.52-1.07-1.24,0-2.22.45-2.92,1.36-.7.9-1.06,2.16-1.06,3.79,0,1.4.34,2.52,1.01,3.36.68.83,1.57,1.25,2.69,1.25s2.04-.4,2.75-1.2c.71-.8,1.07-1.83,1.07-3.08Z" />
				<polygon points="323.78 336.57 315.34 357.08 313.46 357.08 321.87 336.57 323.78 336.57" />
				<path d="m325.82,354.16v-17.59h4.86c6.2,0,9.3,2.86,9.3,8.58,0,2.72-.86,4.9-2.59,6.55-1.72,1.64-4.02,2.47-6.91,2.47h-4.66Zm2.06-15.73v13.86h2.63c2.31,0,4.1-.62,5.39-1.85s1.93-2.99,1.93-5.25c0-4.51-2.4-6.76-7.19-6.76h-2.75Zm16.24-.02c-.36,0-.67-.12-.92-.37-.25-.25-.38-.56-.38-.93s.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.56.38-.93.38Zm.98,15.75h-2.01v-12.56h2.01v12.56Zm14.42,0h-2.01v-7.17c0-2.67-.97-4-2.92-4-1.01,0-1.84.38-2.5,1.14-.65.75-.98,1.71-.98,2.86v7.17h-2.01v-12.56h2.01v2.09h.05c.95-1.59,2.32-2.38,4.12-2.38,1.37,0,2.43.45,3.15,1.34.73.88,1.09,2.16,1.09,3.84v7.68Zm4.75-15.75c-.36,0-.67-.12-.92-.37-.25-.25-.38-.56-.38-.93s.13-.69.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.25.39.56.39.93s-.13.67-.39.92c-.25.25-.56.38-.93.38Zm.98,15.75h-2.01v-12.56h2.01v12.56Zm14.42,0h-2.01v-7.17c0-2.67-.97-4-2.92-4-1.01,0-1.84.38-2.5,1.14-.65.75-.98,1.71-.98,2.86v7.17h-2.01v-12.56h2.01v2.09h.05c.95-1.59,2.32-2.38,4.12-2.38,1.37,0,2.43.45,3.15,1.34.73.88,1.09,2.16,1.09,3.84v7.68Zm14.44-1.01c0,4.61-2.21,6.92-6.63,6.92-1.55,0-2.91-.29-4.07-.88v-2.01c1.42.79,2.76,1.18,4.05,1.18,3.09,0,4.64-1.64,4.64-4.93v-1.37h-.05c-.96,1.6-2.4,2.4-4.32,2.4-1.56,0-2.82-.56-3.78-1.67-.95-1.12-1.42-2.62-1.42-4.5,0-2.13.51-3.83,1.53-5.09,1.03-1.26,2.44-1.89,4.22-1.89s2.95.68,3.77,2.04h.05v-1.74h2.01v11.56Zm-2.01-4.67v-1.85c0-1-.34-1.85-1.02-2.56-.67-.71-1.51-1.07-2.52-1.07-1.24,0-2.22.45-2.92,1.36-.7.9-1.06,2.16-1.06,3.79,0,1.4.34,2.52,1.01,3.36.68.83,1.57,1.25,2.69,1.25s2.04-.4,2.75-1.2c.71-.8,1.07-1.83,1.07-3.08Z" />
				<path d="m418.17,354.16h-2.45l-2.94-4.93c-.27-.46-.53-.85-.79-1.17-.25-.33-.52-.59-.79-.8-.26-.2-.55-.35-.86-.44-.3-.1-.65-.15-1.03-.15h-1.69v7.48h-2.06v-17.59h5.25c.77,0,1.48.1,2.12.29.65.19,1.22.48,1.69.87.48.39.86.88,1.13,1.47.27.58.4,1.26.4,2.05,0,.61-.09,1.18-.28,1.69-.18.51-.44.96-.79,1.36-.34.4-.74.74-1.23,1.03-.47.28-1.01.49-1.61.65v.05c.29.13.55.28.76.45.22.16.43.36.63.59.2.23.39.49.58.79.2.29.41.62.65,1.01l3.3,5.29Zm-10.55-15.73v6.38h2.8c.52,0,.99-.08,1.42-.23.44-.16.82-.38,1.14-.66.32-.29.57-.65.75-1.07.18-.43.27-.9.27-1.42,0-.94-.31-1.67-.92-2.2-.61-.53-1.48-.8-2.64-.8h-2.82Zm17.87,16.02c-1.86,0-3.34-.58-4.45-1.75-1.1-1.18-1.66-2.74-1.66-4.67,0-2.11.58-3.76,1.73-4.94,1.15-1.19,2.71-1.78,4.67-1.78s3.33.58,4.38,1.73c1.06,1.15,1.58,2.75,1.58,4.8s-.57,3.61-1.71,4.82c-1.13,1.2-2.65,1.8-4.55,1.8Zm.15-11.46c-1.29,0-2.31.44-3.07,1.33-.75.88-1.13,2.09-1.13,3.63s.38,2.66,1.14,3.52c.76.86,1.78,1.29,3.06,1.29s2.3-.42,2.99-1.26c.7-.84,1.06-2.04,1.06-3.59s-.35-2.78-1.06-3.63c-.7-.85-1.69-1.28-2.99-1.28Zm14.5,11.46c-1.86,0-3.34-.58-4.45-1.75-1.1-1.18-1.66-2.74-1.66-4.67,0-2.11.58-3.76,1.73-4.94,1.15-1.19,2.71-1.78,4.67-1.78s3.33.58,4.38,1.73c1.06,1.15,1.58,2.75,1.58,4.8s-.57,3.61-1.71,4.82c-1.13,1.2-2.65,1.8-4.55,1.8Zm.15-11.46c-1.29,0-2.31.44-3.07,1.33-.75.88-1.13,2.09-1.13,3.63s.38,2.66,1.14,3.52c.76.86,1.78,1.29,3.06,1.29s2.3-.42,2.99-1.26c.7-.84,1.06-2.04,1.06-3.59s-.35-2.78-1.06-3.63c-.7-.85-1.69-1.28-2.99-1.28Zm27.09,11.17h-2.01v-7.21c0-1.39-.22-2.4-.65-3.02-.43-.62-1.15-.93-2.16-.93-.86,0-1.59.39-2.2,1.18-.6.79-.9,1.73-.9,2.82v7.17h-2.01v-7.46c0-2.47-.95-3.71-2.86-3.71-.88,0-1.61.37-2.18,1.12-.57.74-.86,1.7-.86,2.88v7.17h-2.01v-12.56h2.01v1.99h.05c.89-1.52,2.19-2.28,3.9-2.28.86,0,1.61.24,2.25.72.64.47,1.08,1.1,1.31,1.88.93-1.73,2.32-2.6,4.17-2.6,2.76,0,4.15,1.71,4.15,5.12v7.74Z" />
				<path d="m315.11,380.24h-1.46v-11.06c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.12-.59.22-.87.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.08Zm12.51-6.45c0,1.07-.1,2.02-.29,2.85-.19.83-.47,1.53-.84,2.1-.36.57-.81,1-1.35,1.29-.53.29-1.13.44-1.81.44-.64,0-1.22-.14-1.72-.42-.5-.29-.92-.7-1.27-1.24-.35-.54-.61-1.2-.79-1.99-.18-.79-.27-1.7-.27-2.71,0-1.12.09-2.11.28-2.96.19-.86.47-1.57.83-2.15.36-.58.81-1.02,1.35-1.31.54-.3,1.16-.45,1.86-.45,2.68,0,4.02,2.19,4.02,6.56Zm-1.5.14c0-3.64-.87-5.46-2.6-5.46-1.83,0-2.74,1.85-2.74,5.56,0,3.46.9,5.18,2.69,5.18s2.65-1.76,2.65-5.28Z" />
				<rect x="329.84" y="367.45" width="1.29" height="3.99" />
				<path d="m341.63,373.79c0,1.07-.1,2.02-.29,2.85-.19.83-.47,1.53-.84,2.1-.36.57-.81,1-1.35,1.29-.53.29-1.13.44-1.81.44-.64,0-1.22-.14-1.72-.42-.5-.29-.92-.7-1.27-1.24-.35-.54-.61-1.2-.79-1.99-.18-.79-.27-1.7-.27-2.71,0-1.12.09-2.11.28-2.96.19-.86.47-1.57.83-2.15.36-.58.81-1.02,1.35-1.31.54-.3,1.16-.45,1.86-.45,2.68,0,4.02,2.19,4.02,6.56Zm-1.5.14c0-3.64-.87-5.46-2.6-5.46-1.83,0-2.74,1.85-2.74,5.56,0,3.46.9,5.18,2.69,5.18s2.65-1.76,2.65-5.28Z" />
				<path d="m345.14,367.45v3.99h-1.29v-3.99h1.29Zm2.96,0v3.99h-1.29v-3.99h1.29Z" />
				<path d="m362.73,371.1l-3.07,4.62,3.02,4.52h-1.7l-1.79-2.96c-.11-.18-.25-.42-.4-.7h-.04c-.03.05-.17.29-.42.7l-1.83,2.96h-1.69l3.11-4.48-2.98-4.66h1.7l1.77,3.12c.13.23.26.47.38.71h.04l2.28-3.84h1.62Z" />
				<path d="m374.44,380.24h-1.46v-11.06c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.12-.59.22-.87.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.08Zm12.37-7.17c0,1.17-.12,2.22-.35,3.13-.23.91-.57,1.68-1.02,2.32-.45.63-.99,1.11-1.63,1.45-.64.33-1.37.49-2.2.49s-1.59-.15-2.23-.45v-1.4c.71.4,1.46.6,2.27.6.58,0,1.09-.12,1.54-.36.46-.24.84-.58,1.16-1.04.32-.46.56-1.02.72-1.69.17-.67.25-1.43.25-2.29h-.04c-.55,1.1-1.5,1.65-2.86,1.65-.55,0-1.05-.1-1.51-.29-.46-.2-.85-.47-1.19-.82-.33-.36-.59-.78-.78-1.27s-.28-1.03-.28-1.62c0-.63.1-1.21.3-1.73.21-.52.49-.97.86-1.35.37-.38.8-.68,1.3-.88.51-.21,1.06-.31,1.65-.31.64,0,1.21.13,1.7.39.5.26.92.63,1.26,1.13.34.49.6,1.1.78,1.83.18.73.27,1.56.27,2.49Zm-1.58-1.31c0-.49-.07-.94-.2-1.35-.12-.4-.3-.75-.53-1.04-.23-.29-.5-.51-.81-.67-.31-.16-.65-.24-1.02-.24s-.68.07-.98.21c-.3.14-.57.33-.79.59-.22.25-.4.55-.53.9-.12.35-.19.72-.19,1.13,0,.45.06.86.18,1.21.12.36.3.66.53.91.23.24.5.43.81.56.32.13.68.2,1.06.2.34,0,.66-.06.95-.19.3-.13.57-.3.79-.52.23-.22.4-.48.53-.77.13-.3.2-.62.2-.95Z" />
				<rect x="389.17" y="367.45" width="1.29" height="3.99" />
				<path d="m398.31,380.24h-1.46v-11.06c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.12-.59.22-.87.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.08Z" />
				<path d="m404.47,367.45v3.99h-1.29v-3.99h1.29Zm2.96,0v3.99h-1.29v-3.99h1.29Z" />
				<path d="m661.31,622.11l-2.89,10.24h-1.41l-2.11-7.48c-.09-.32-.15-.67-.16-1.04h-.03c-.03.35-.09.69-.19,1.03l-2.12,7.5h-1.39l-3-10.24h1.32l2.18,7.85c.09.33.15.67.17,1.03h.04c.02-.25.1-.6.22-1.03l2.26-7.85h1.15l2.17,7.91c.08.27.13.59.17.96h.03c.02-.25.08-.58.19-.99l2.09-7.88h1.3Z" />
				<polygon points="667.29 622.11 662.37 634.05 661.28 634.05 666.18 622.11 667.29 622.11" />
				<path d="m668.48,632.35v-10.24h2.83c3.61,0,5.41,1.66,5.41,4.99,0,1.58-.5,2.85-1.51,3.81-1,.96-2.34,1.44-4.02,1.44h-2.71Zm1.2-9.15v8.07h1.53c1.34,0,2.39-.36,3.13-1.08.75-.72,1.12-1.74,1.12-3.06,0-2.62-1.39-3.93-4.18-3.93h-1.6Z" />
			</g>
		</g>
	)
}

export default PlanE
